/**
 * Arabic Translations
 * الترجمات العربية
 */
export const ar = {
    // العامة
    app_title: 'ديولي',
    app_subtitle: 'تواصل عبر التنافس',
    home: 'الرئيسية',
    explore: 'استكشف',
    live: 'بث مباشر',
    // 7.A: إشارات WebRTC — مفاتيح فرعية تحت مساحة مخصصة (لا new String)
    live_signaling: {
        connecting: 'جارٍ الاتصال...',
        connected: 'متصل',
        connection_failed: 'فشل الاتصال',
        permission_denied: 'تم رفض الإذن',
        // 7.D: شبكات مقيّدة / TURN
        network_restricted: 'قد تكون شبكتك مقيّدة — جارٍ محاولة الاتصال عبر خادم ترحيل',
        turn_unavailable: 'تعذّر الوصول إلى خادم الترحيل (TURN) حالياً — أعد المحاولة أو استخدم شبكة مختلفة',
        // R4-LIVE-INT-1: فشل الانضمام في غرفة الإنتاج (تنبيه مرئي، لا سجل)
        room_create_failed: 'تعذّر إنشاء غرفة الإشارات. يرجى إعادة تحميل الصفحة والمحاولة مجددًا.',
        session_join_failed: 'تعذّر الانضمام إلى الجلسة المباشرة. يرجى إعادة تحميل الصفحة والمحاولة مجددًا.',
        // R4-CHUNK-VIEW-RECOVERY-1 (28.4): انتهى التسجيل دون مقاطع قابلة للتشغيل
        recording_ended: 'انتهى التسجيل — لا توجد مقاطع قابلة للتشغيل.',
    },
    recorded: 'مسجل',
    upcoming: 'اللاحقة',
    profile: 'الملف الشخصي',
    settings: 'الإعدادات',
    logout: 'تسجيل الخروج',
    login: 'دخول',
    register: 'إنشاء حساب',
    search_placeholder: 'ابحث عن منافسة، عالم، أو موهبة...',
    filter: 'تصفية',
    all: 'الجميع',
    help: 'مساعدة',
    skip_to_content: 'تخطَّ إلى المحتوى الرئيسي',
    docs: 'الوثائق',
    docs_tagline: 'ملاحظات المشروع والمنتج والهندسة التي ينشرها فريق ديولي.',
    docs_empty: 'لا توجد وثائق منشورة بعد.',
    docs_back: 'عودة إلى الوثائق',
    help_guide: {
        title: 'المساعدة والأدلة',
        subtitle: 'كيف تنشئ وتنافس وتشاهد على ديولي — مع إجابات عن الأسئلة الشائعة.',
        learn_more: 'اعرف المزيد',
        nav_overview: 'نظرة عامة',
        nav_roles: 'أدلة الأدوار',
        nav_topics: 'المواضيع',
        nav_faq: 'الأسئلة الشائعة',
        nav_access: 'إمكانية الوصول',
        overview_t: 'كيف تعمل ديولي',
        overview_d: 'أنشئ منافسة، واستضف خصماً واحداً عبر الدعوات أو طلبات الانضمام، ثم ابث مباشرة، وتبقى النتيجة وأي تسجيل على صفحة المنافسة.',
        roles_t: 'الأدلة حسب الدور',
        creator_t: 'المنشئ',
        creator_s1t: 'إنشاء المنافسة',
        creator_s1d: 'افتح صفحة الإنشاء، واختر القسم والقسم الفرعي، واكتب قواعد واضحة، وحدد موعداً مجدولاً عند الحاجة. تبدأ المنافسة معلقة حتى ينضم خصم.',
        creator_s2t: 'دعوة خصم',
        creator_s2d: 'أرسل دعوة من صفحة المنافسة أو أجب عن طلبات الانضمام في طلباتي. الدعوة المعلقة تمنع طلب انضمام موازياً من الشخص نفسه، وقبول واحد يملأ مقعد الخصم الوحيد.',
        creator_s3t: 'البث والإنهاء',
        creator_s3d: 'ابدأ البث عندما يكون الطرفان جاهزين، وأنهِ من عناصر التحكم في الغرفة. بعد النهاية تُغلق التقييمات فوراً وتصبح النتيجة نهائية للقراءة فقط.',
        opponent_t: 'الخصم',
        opponent_s1t: 'جد منافسة أو اقبل دعوة',
        opponent_s1d: 'تصفح الاستكشاف بحثاً عن منافسات معلقة، أو افتح دعوة من طلباتي. اقبل أو ارفض من صفحة المنافسة؛ تنتهي الدعوات بعد 24 ساعة.',
        opponent_s2t: 'ادخل غرفة البث',
        opponent_s2d: 'ادخل من صفحة المنافسة عندما تبدأ البث. استخدم عناصر الغرفة للكاميرا والميكروفون والاتصال، واستخدم إعادة المحاولة إذا ظهرت حالة خطأ.',
        opponent_s3t: 'بعد المنافسة',
        opponent_s3d: 'اقرأ النتيجة النهائية على صفحة المنافسة. إذا توفر تسجيل فسيعمل هناك؛ والمنافسة المكتملة بلا تسجيل تعرض النتيجة فقط.',
        viewer_t: 'المشاهد',
        viewer_s1t: 'المشاهدة المباشرة',
        viewer_s1d: 'افتح منافسة مباشرة من الرئيسية أو الاستكشاف. يمكن للمشاهدين المباشرين التعليق أثناء البث.',
        viewer_s2t: 'التقييم بعد 5 دقائق',
        viewer_s2d: 'بعد 300 ثانية من المشاهدة الحية في المنافسة نفسها يمكنك تقييم كل متنافس من 1 إلى 5 نجوم. يمكنك تقييم الطرفين وتعديل تقييمك حتى النهاية، وترى حصيلة مؤقتة موسومة بأنها غير نهائية أثناء البث.',
        viewer_s3t: 'التفاعل والمتابعة',
        viewer_s3d: 'امنح إعجاباً أو عدم إعجاب (تفاعل فعال واحد — التبديل لا يضاعف العدّ)، وتابع المتنافسين من ملفهم، وواصل النقاش في التعليقات بعد النهاية.',
        topics_t: 'المواضيع',
        topic_create_t: 'إنشاء المنافسة',
        topic_create_d: 'العنوان والقسم والقواعد مع موعد مجدول اختياري. المنافسات المعلقة تنتظر خصماً؛ والمنافسة المغلقة تعطل الدعوة والانضمام مع ذكر السبب.',
        topic_invite_t: 'الدعوات وطلبات الانضمام',
        topic_invite_d: 'الدعوة المعلقة لشخص ما تمنع طلب انضمام موازياً منه، والعكس صحيح. اقبل أو ارفض من صفحة المنافسة؛ والصفوف المنتهية أو المرفوضة تفتح الطريق مجدداً. السباقات تُحسم لخصم واحد فقط.',
        topic_live_t: 'حالات غرفة البث',
        topic_live_d: 'تعرض الغرفة: انتظار أو تشغيل أو خطأ أو معالجة أو جاهز أو غير متاح حسب بيانات الوسائط الفعلية. الانتظار يعني عدم وجود بث قابل للتشغيل بعد؛ وعند الخطأ استخدم زر إعادة المحاولة.',
        topic_recording_t: 'التسجيلات',
        topic_recording_d: 'المنافسة المكتملة ذات التسجيل الصالح تعمل على صفحتها. والمكتملة بلا تسجيل صفحة نتيجة وليست فيديو قابلاً للمشاهدة.',
        topic_ratings_t: 'التقييمات (300 ثانية)',
        topic_ratings_d: 'الأهلية تتطلب 300 ثانية من المشاهدة الحية التراكمية في المنافسة نفسها — فتح الصفحة وحده لا يكفي. يُقيَّم المتنافسان من 1 إلى 5، والتعديل يستبدل القيمة السابقة، وتتوقف كل الكتابات عند النهاية، والتعادل أو غياب التقييمات لا يصنع فائزاً وهمياً.',
        topic_reactions_t: 'الإعجاب وعدم الإعجاب',
        topic_reactions_d: 'تفاعل فعال واحد لكل شخص: إعجاب أو عدم إعجاب أو محايد. التبديل ينقل العدّ ولا يضيفه مرتين أبداً.',
        topic_comments_t: 'التعليقات والتعليقات الموقوتة',
        topic_comments_d: 'تبقى التعليقات مفتوحة بعد النهاية. التعليق أثناء تشغيل التسجيل قد يحمل موضعه الزمني، ويتبع التشغيل عند الوصول إليه، وتبقى القائمة النهائية مرتبة زمنياً.',
        topic_discover_t: 'الاكتشاف والبحث والمفضلات',
        topic_discover_d: 'صفِّ الاستكشاف حسب القسم والقسم الفرعي والحالة واللغة؛ ويحفظ شريط العنوان المرشحات. احفظ المواضيع المفضلة في الإعدادات لتخصيص الاقتراحات.',
        topic_payout_t: 'الأرباح والسحب والتبرعات',
        topic_payout_d: 'احفظ طرق الصرف في الأرباح واختر واحدة عند طلب السحب؛ ويحتفظ الطلب بلقطة مجمدة من بيانات الطريقة فلا تغيره التعديلات اللاحقة. صفحة التبرع تعرض التبرعات كغير قابلة للاسترداد، وسجلك تحت تبرعاتي.',
        topic_support_t: 'المساعدة والبلاغات والتواصل',
        topic_support_d: 'استخدم التواصل مع الإدارة في القائمة لفتح تبويب رسائل الإدارة؛ والردود الرسمية تأتي من ديولي لا من حساب شخصي. قدّم البلاغات من صفحة البلاغات وتابع الشكاوى تحت شكاواي. لوحة الإدارة ظاهرة للمشرفين فقط.',
        faq_t: 'الأسئلة الشائعة',
        faq_q1: 'كيف أنشئ منافسة؟',
        faq_a1: 'انتقل إلى الإنشاء، واملأ العنوان والقسم والقواعد، ثم ادعُ خصماً من صفحة المنافسة. راجع دليل المنشئ أعلاه.',
        faq_q2: 'لماذا لا أستطيع طلب الانضمام؟',
        faq_a2: 'ربما لديك دعوة معلقة لتلك المنافسة، أو امتلأ مقعد الخصم، أو أُغلقت المنافسة. تعرض الصفحة السبب.',
        faq_q3: 'متى يمكنني التقييم؟',
        faq_a3: 'بعد 300 ثانية من المشاهدة الحية في المنافسة نفسها. توضح بطاقة التقييم هل أصبحت مؤهلاً.',
        faq_q4: 'هل يمكنني تعديل تقييمي؟',
        faq_a4: 'نعم — حتى نهاية البث. كل تعديل يستبدل قيمتك السابقة، والحصيلة الحية موسومة بأنها مؤقتة حتى النتيجة النهائية.',
        faq_q5: 'لماذا أصبحت النتيجة للقراءة فقط؟',
        faq_a5: 'انتهت المنافسة. تُغلق التقييمات عند النهاية وتُجمَّد النتيجة النهائية بما فيها معالجة التعادل.',
        faq_q6: 'أين التسجيل؟',
        faq_a6: 'على صفحة المنافسة عند وجود تسجيل صالح. وإلا تعرض الصفحة النتيجة دون مشغل.',
        faq_q7: 'ماذا يفعل الإعجاب وعدم الإعجاب؟',
        faq_a7: 'تفاعلان على المحتوى بقيمة فعالة واحدة لكل شخص. والتبديل لا يضاعف العدّ أبداً.',
        faq_q8: 'كيف أسحب أرباحي؟',
        faq_a8: 'أضف طريقة صرف في الأرباح ثم اخترها عند طلب السحب. يحتفظ الطلب بلقطة من بيانات الطريقة.',
        faq_q9: 'هل التبرعات قابلة للاسترداد؟',
        faq_a9: 'صفحة التبرع تعرضها كغير قابلة للاسترداد. ويظهر سجلك تحت تبرعاتي.',
        faq_q10: 'كيف أتواصل مع الدعم أو أبلغ عن إساءة؟',
        faq_a10: 'استخدم التواصل مع الإدارة لتبويب رسائل الإدارة، والبلاغات لتقديم بلاغ، وشكاواي للمتابعة.',
        access_t: 'لوحة المفاتيح والتكبير واللغة',
        access_d: 'كل صفحات المساعدة تعمل بلوحة المفاتيح فقط: التنقل بزر Tab، والفتح بزر Enter، وإغلاق الحوارات بزر Escape. يبقى التكبير بالقرص ممكناً، والعربية تُقرأ من اليمين لليسار والإنجليزية من اليسار لليمين. إذا واجهك أي عائق فتواصل مع الإدارة من القائمة.',
    },
    theme: 'الوضع الليلي/النهاري',
    language: 'اللغة',
    country_language: 'البلد واللغة',
    search_country: 'ابحث عن بلد...',
    users: 'المستخدمون',
    verified: 'موثق',
    busy_in_stream: 'مشغول في بث',
    search_results_for: 'نتائج البحث عن',
    no_users: 'لا يوجد مستخدمون',
    search_users_prompt: 'أدخل كلمة للبحث عن المستخدمين',
    // نتائج البحث — بنية 6+6 وعرض الكل (قبول المالك، بلا تغيير في الاسترجاع)
    view_all_competitions: 'عرض كل المنافسات',
    view_all_users: 'عرض كل المستخدمين',
    back_to_results: 'عودة إلى النتائج',
    filters: 'تصفية',
    showing_first: 'عرض أول النتائج',

    // الأقسام الرئيسية
    categories: {
        dialogue: 'الحوار',
        science: 'العلوم',
        talents: 'المواهب',

        // أقسام الحوار الفرعية
        religions: 'حوار الأديان',
        sects: 'حوار المذاهب الدينية',
        politics: 'حوار السياسة',
        economics: 'حوار الاقتصاد',
        ethnic_conflicts: 'حوار النزاعات العرقية',
        local_events: 'أهم الأحداث المحلية',
        global_events: 'أهم الأحداث العالمية',
        disputes: 'نزاعات أخرى',
        other_disputes: 'نزاعات أخرى',

        // أقسام العلوم الفرعية
        physics: 'علوم الفيزياء',
        chemistry: 'علوم الكيمياء',
        math: 'علوم الرياضيات',
        astronomy: 'علوم الفلك',
        biology: 'علوم الأحياء',
        technology: 'علوم التكنولوجيا',
        energy: 'علوم الطاقة',
        economics_science: 'علوم الاقتصاد',
        mixed: 'علوم مختلطة',
        other_science: 'علوم أخرى',

        // أقسام المواهب الفرعية
        physical: 'مواهب بدنية',
        mental: 'مواهب عقلية',
        vocal: 'مواهب صوتية',
        poetry: 'مواهب شعرية',
        psychological: 'مواهب نفسية',
        creative: 'مواهب إبداعية',
        crafts: 'مواهب حرفية',
        other_talents: 'مواهب أخرى'
    },

    // أقسام العرض
    sections: {
        suggested: 'مقترح لك',
        dialogue: 'ساحة الحوار',
        science: 'المختبر العلمي',
        talents: 'مسرح المواهب'
    },

    // المنافسات
    competition: {
        self: 'منافسة',
        // ── B12: نتيجة المنافسة (فائز/تعادل/معلقة) ──────────────
        winner: 'فائز',
        draw: 'تعادل',
        pending_result: 'النتيجة لم تُحسم بعد',
    },
    competitions: 'المنافسات',
    create_competition: 'إنشاء منافسة',
    join_competition: 'انضم للمنافسة',
    watch_competition: 'شاهد المنافسة',
    competition_title: 'عنوان المنافسة',
    competition_rules: 'قوانين المنافسة',
    competition_description: 'وصف المنافسة',
    select_category: 'اختر القسم',
    select_subcategory: 'اختر القسم الفرعي',
    scheduled_time: 'موعد البدء',
    request_join: 'طلب الانضمام',
    cancel_request: 'إلغاء الطلب',
    request_sent: 'تم إرسال الطلب',
    rules_placeholder: '1. مدة الحديث لكل طرف\n2. قواعد الحوار\n3. معايير التقييم',
    error_occurred: 'حدث خطأ',

    // الحالات
    status_pending: 'في انتظار منافس',
    status_accepted: 'تم القبول',
    status_declined: 'مرفوضة',
    status_rejected: 'مرفوضة',
    status_auto_declined: 'رُفضت تلقائياً',
    status_expired: 'منتهية الصلاحية',
    status_live: 'مباشر',
    status_completed: 'منتهية',
    status_cancelled: 'ملغاة',
    status_ongoing: 'مستمر',

    // التفاعل
    invite: 'دعوة',
    accept: 'قبول',
    decline: 'رفض',
    cancel: 'إلغاء',
    send: 'إرسال',
    save: 'حفظ',
    edit: 'تعديل',
    delete: 'حذف',
    follow: 'متابعة',
    unfollow: 'إلغاء المتابعة',
    block: 'حظر',
    unblock: 'إلغاء الحظر',
    confirm_block: 'حظر هذا المستخدم؟ لن يتمكن من مراسلتك أو التفاعل معك.',
    confirm_unblock: 'إلغاء حظر هذا المستخدم؟',
    user_blocked: 'تم حظر المستخدم.',
    user_unblocked: 'تم إلغاء حظر المستخدم.',

    // التقييم
    rate: 'قيّم',
    rating: 'التقييم',
    viewers: 'مشاهدة',
    // R2-L1: الحضور اللحظي يعرض مستقلاً عن إجمالي المشاهدات المحتسبة.
    viewers_now: 'يشاهدون الآن',

    // التعليقات
    comment: 'تعليق',
    comments: {
        label: 'التعليقات',
        load_more: 'عرض المزيد من التعليقات',
        no_comments: 'لا توجد تعليقات بعد',
        reply: 'رد',
        deleted: 'تم حذف التعليق',
    },
    reports: {
        reason_comment: 'تعليق مسيء',
        reason_message: 'رسالة مسيئة',
    },
    add_comment: 'أضف تعليقاً',
    live_chat: 'المحادثة المباشرة',

    // تسجيل الدخول
    login_with_google: 'الدخول بحساب Google',
    login_with_facebook: 'الدخول بحساب Facebook',
    login_with_microsoft: 'الدخول بحساب Microsoft',
    login_with_twitter: 'الدخول بحساب X',
    login_welcome: 'مرحباً بك في ديولي',
    login_subtitle: 'سجل دخولك للمشاركة في المنافسات',
    login_button: 'تسجيل الدخول',
    register_button: 'إنشاء حساب',
    email_label: 'البريد الإلكتروني',
    password_label: 'كلمة المرور',
    name_label: 'الاسم',
    forgot_password: 'نسيت كلمة المرور؟',
    or_divider: 'أو',
    terms_agreement: 'بالمتابعة، أنت توافق على شروط الخدمة وسياسة الخصوصية',
    back_to_login: 'العودة لتسجيل الدخول',
    reset_password_title: 'استعادة كلمة المرور',
    send_code: 'إرسال رمز التحقق',
    verification_code_label: 'رمز التحقق',
    code_sent_to_email: 'تم إرسال الرمز إلى بريدك الإلكتروني',
    verify_code: 'تحقق من الرمز',
    new_password_label: 'كلمة المرور الجديدة',
    change_password: 'تغيير كلمة المرور',
    password_min_length: 'كلمة المرور يجب أن تكون 8 أحرف على الأقل',
    or_continue_with: 'أو تابع باستخدام',

    // المستخدم
    user: 'مستخدم',
    username: 'اسم المستخدم',
    email: 'البريد الإلكتروني',
    display_name: 'الاسم المعروض',
    bio: 'نبذة عني',
    country: 'الدولة',
    my_competitions: 'منافساتي',
    my_requests: 'طلباتي',

    // الإحصائيات
    stats: 'الإحصائيات',
    total_competitions: 'إجمالي المنافسات',
    total_wins: 'الانتصارات',
    total_views: 'المشاهدات',
    followers: 'المتابعون',
    following: 'يتابع',
    // R3-D2 Profile (08/11): SUM النجوم ÷ عدد المنافسات الفعلية
    profile_score: 'التقييم العام',
    profile_hint: 'إجمالي النجوم ÷ عدد المنافسات',
    profile_empty: 'لا توجد منافسات بعد',
    profile_participations: 'منافسة',

    // الأخطاء
    error: 'خطأ',
    not_found: 'غير موجود',
    unauthorized: 'غير مصرح',
    forbidden: 'محظور',
    server_error: 'حدث خطأ في الخادم. يرجى المحاولة مرة أخرى.',
    login_required: 'يجب تسجيل الدخول',
    no_duels: 'عذراً، لا توجد منافسات هنا حالياً.',
    try_different_filter: 'جرب تصفية أخرى أو أنشئ منافسة جديدة',
    error_loading: 'حدث خطأ',
    page_not_found: 'الصفحة غير موجودة',
    back_to_home: 'العودة للرئيسية',

    // أخطاء API
    errors: {
        missing_fields: 'الحقول المطلوبة مفقودة',
        content_required: 'المحتوى مطلوب',
        invalid_id: 'معرّف غير صالح',
        invalid_rating: 'التقييم يجب أن يكون بين 1 و 5',
        invalid_request: 'طلب غير صالح',
        fetch_failed: 'فشل في جلب البيانات',
        create_failed: 'فشل في الإنشاء',
        update_failed: 'فشل في التحديث',
        delete_failed: 'فشل في الحذف',
        something_wrong: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
        blocked_interaction: 'لا يمكن إتمام هذا الإجراء',
        rate_limited: 'محاولات كثيرة، حاول بعد قليل',
        content_too_long: 'النص أطول من الحد المسموح',
        comment_not_found: 'التعليق غير موجود',
        not_comment_owner: 'فقط مالك التعليق أو المشرف يمكنه حذفه',
        service_unavailable: 'الخدمة غير متوفرة حالياً. يرجى المحاولة لاحقاً.',
        session_expired: 'انتهت صلاحية الجلسة — حدّث النتائج لعرض الأحدث',
    },

    // الاستكشاف (B13: صلابة صفحات الاكتشاف)
    discovery: {
        no_results: 'لا توجد نتائج لعرضها',
        no_more_results: 'لا توجد نتائج أخرى',
        retry: 'إعادة المحاولة',
        session_expired: 'انتهت صلاحية هذه النتائج',
        refresh: 'تحديث',
    },

    // رسائل أخطاء المنافسة
    competition_errors: {
        not_found: 'المنافسة غير موجودة',
        cannot_join_own: 'لا يمكنك الانضمام لمنافستك',
        already_requested: 'لقد طلبت الانضمام مسبقاً',
        not_completed: 'المنافسة لم تنتهي بعد',
        already_rated: 'لقد قيمت هذا المتنافس مسبقاً',
        not_eligible_to_start: 'لا يمكن بدء المنافسة في حالتها الحالية',
        no_opponent: 'لا يمكن البدء بدون خصم',
        not_live: 'المنافسة ليست جارية',
        already_completed: 'المنافسة منتهية بالفعل',
        vod_url_required: 'رابط التسجيل مطلوب',
        already_has_opponent: 'المنافسة لديها خصم بالفعل',
        delete_not_allowed: 'لا يمكن حذف هذه المنافسة بعد الآن',
        invitee_required: 'يجب تحديد المدعو',
        cannot_invite_self: 'لا يمكنك دعوة نفسك',
        already_invited: 'تمت دعوة المستخدم مسبقاً',
        no_pending_invitation: 'لا توجد دعوة معلقة',
        no_pending_request: 'لا يوجد طلب معلق',
        request_already_accepted: 'تم قبول الطلب مسبقاً',
        already_competitor: 'المستخدم متنافس في هذه المنافسة بالفعل',
        competition_full: 'المنافسة ممتلئة',
        opponent_already_set: 'تم تعيين الخصم بالفعل',
        invitation_not_found: 'الدعوة غير موجودة أو منتهية',
        blocked_user: 'لا يمكن التفاعل مع هذا المستخدم',
        not_authorized: 'غير مصرح لك بهذا الإجراء',
        // R2-J (H3): المسارات المتعارضة لنفس المنافسة
        invite_pending_exists: 'لديك دعوة معلقة لهذه المنافسة — اقبلها أو ارفضها أولاً',
        request_pending_exists: 'لدى المستخدم طلب انضمام معلق لهذه المنافسة',
        competition_closed: 'هذه المنافسة لم تعد تقبل مشاركين',
        rating_self_forbidden: 'لا يمكنك تقييم نفسك أو منافستك',
        rating_watch_required: 'شاهد 300 ثانية من البث المباشر أولاً لتتمكن من التقييم',
        rating_window_closed: 'انتهى البث — التقييم مغلق والنتيجة نهائية',
        rating_live_only: 'التقييم متاح أثناء البث المباشر فقط',
        rating_updated: 'تحديث التقييم',
        rating_replaced: 'تم تحديث تقييمك',
    },

    // رسائل أخطاء المستخدم
    user_errors: {
        not_found: 'المستخدم غير موجود',
        cannot_follow_self: 'لا يمكنك متابعة نفسك',
    },

    // رسائل الفئة
    category: {
        not_found: 'الفئة غير موجودة',
    },

    // النجاح
    success: 'تم بنجاح',

    // Footer
    footer: '© 2026 ديولي. جميع الحقوق محفوظة.',
    about: 'عن المنصة',
    contact: 'تواصل معنا',
    terms: 'الشروط والأحكام',
    privacy: 'سياسة الخصوصية',

    // الإجراءات
    view_all: 'عرض الكل',
    load_more: 'تحميل المزيد',
    back: 'رجوع',
    close: 'إغلاق',
    submit: 'إرسال',
    loading: 'جاري التحميل...',
    no_more: 'لا توجد نتائج أخرى',
    go_home: 'اذهب إلى الرئيسية',
    go_back: 'العودة',
    previous: 'السابق',
    next: 'التالي',

    // المصادقة - رسائل API
    auth_all_fields_required: 'جميع الحقول مطلوبة',
    auth_email_exists: 'البريد الإلكتروني مستخدم بالفعل',
    auth_register_success: 'تم التسجيل بنجاح! يرجى التحقق من بريدك الإلكتروني.',
    auth_register_failed: 'حدث خطأ أثناء التسجيل',
    auth_invalid_link: 'رابط التفعيل غير صالح أو منتهي',
    auth_account_activated: 'تم تفعيل حسابك بنجاح!',
    auth_email_password_required: 'البريد الإلكتروني وكلمة المرور مطلوبان',
    auth_invalid_credentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    auth_social_no_password: 'هذا الحساب مسجل عبر المصادقة الاجتماعية (Google/Microsoft/Facebook). سجّل الدخول عبر مزوّدك، أو أعد تعيين كلمة المرور لتتمكن من الدخول بالبريد.',
    auth_email_is_social: 'هذا البريد مسجل عبر المصادقة الاجتماعية. سجّل الدخول عبر مزوّدك (Google/Microsoft/Facebook) أو أعد تعيين كلمة المرور.',
    auth_verify_email_first: 'يرجى تفعيل حسابك أولاً',
    auth_email_required: 'البريد الإلكتروني مطلوب',
    auth_user_not_found: 'المستخدم غير موجود أو تم تفعيله بالفعل',
    auth_verification_resent: 'تم إرسال رابط التفعيل مجدداً',
    auth_reset_if_exists: 'إذا كان هذا البريد مسجلاً، ستصلك رسالة إعادة تعيين',
    auth_reset_code_sent: 'تم إرسال رمز إعادة التعيين إلى بريدك',
    auth_check_spam_folder: 'إذا لم تجد الرسالة، تحقق من مجلد البريد غير المرغوب فيه (Spam).',
    auth_email_code_required: 'البريد والرمز مطلوبان',
    auth_invalid_code: 'الرمز غير صحيح أو منتهي',
    auth_code_verified: 'تم التحقق من الرمز',
    auth_password_required: 'كلمة المرور الجديدة مطلوبة',
    auth_password_changed: 'تم تغيير كلمة المرور بنجاح',
    auth_email_not_verified: 'يرجى تفعيل بريدك الإلكتروني قبل تسجيل الدخول',
    auth_invalid_token: 'رمز غير صالح أو منتهي الصلاحية',
    auth_email_verified: 'تم تفعيل بريدك الإلكتروني بنجاح! يمكنك الآن تسجيل الدخول.',
    auth_connection_failed: 'فشل الاتصال. يرجى المحاولة مرة أخرى.',

    // التحقق
    verification_failed: 'حدث خطأ أثناء التحقق',
    verification_invalid_link: 'رابط غير صالح',
    verification_success_msg: 'يمكنك الآن تسجيل الدخول إلى حسابك',
    verification_check_link: 'يرجى التحقق من الرابط أو طلب رابط جديد',
    account_verification: 'تفعيل الحساب',

    // صفحة عن ديولي
    about_title: 'منصة ديولي للمنافسات',
    about_description: 'المنصة الأولى من نوعها التي تجمع بين المنافسات الحية، الحوارات البناءة، واكتشاف المواهب في بيئة تفاعلية عادلة.',
    about_live_streaming: 'بث مباشر وتفاعل حي',
    about_live_streaming_desc: 'نظام بث متطور يجمع المتنافسين جنباً إلى جنب مع إمكانية تفاعل الجمهور والتصويت المباشر.',
    about_fair_judging: 'نظام تحكيم عادل',
    about_fair_judging_desc: 'آليات تحكيم شفافة تعتمد على تصويت الجمهور ولجان التحكيم المختصة لضمان العدالة.',
    about_global_community: 'مجتمع عالمي',
    about_global_community_desc: 'تواصل مع مبدعين ومفكرين من مختلف أنحاء العالم وشارك في منافسات عابرة للحدود.',
    about_platform_preview: 'نظرة على المنصة',
    about_developed_by: 'تم التطوير بواسطة Maelsh',
    about_maelsh_desc: 'نحن في Maelsh نؤمن بقوة الحوار والمنافسة الشريفة في بناء المجتمعات. نسعى لتقديم حلول برمجية مبتكرة تجمع بين الجمالية والوظيفة لخدمة المستخدم العربي والعالمي.',
    about_dueli: 'عن ديولي',

    // صفحة المنافسة
    competitors: 'المتنافسون',
    competition_share: {
        share_button: 'مشاركة المنافسة',
        dialog_title: 'شارك هذه المنافسة',
        copy_link: 'نسخ الرابط',
        copy_success: 'تم نسخ الرابط',
        copy_failed: 'تعذّر نسخ الرابط',
        close: 'إغلاق',
        platform_whatsapp: 'واتساب',
        platform_telegram: 'تيليجرام',
        platform_facebook: 'فيسبوك',
        platform_x: 'X',
        platform_linkedin: 'لينكدإن',
        platform_email: 'البريد',
    },
    awaiting_opponent: 'بانتظار منافس',
    login_to_compete: 'سجل دخول للمنافسة',
    stream_not_available: 'البث غير متاح',
    no_comments_yet: 'لا توجد تعليقات بعد',
    new_follower: 'متابع جديد',

    // البريد الإلكتروني
    email_activate_subject: 'تفعيل حسابك في ديولي',
    email_reset_subject: 'إعادة تعيين كلمة المرور',

    // الإشعارات
    notification: {
        new_join_request: 'طلب انضمام جديد',
        join_request_for: 'طلب انضمام للمنافسة',
        request_accepted: 'تم قبول طلبك',
        request_accepted_message: 'تم قبول طلبك للانضمام للمنافسة',
        new_message: 'رسالة جديدة',
        new_message_body: '{actor}: {preview}',
        // R2-M: رد إداري رسمي — عنوان مستقل عن الرسائل الشخصية.
        new_admin_message: 'رسالة جديدة من دعم Dueli',
        new_admin_message_body: '{preview}',
        new_post_like: 'إعجاب جديد على منشورك',
        new_post_like_body: '{actor} أعجب بمنشورك',
        new_post_comment: 'تعليق جديد على منشورك',
        new_post_comment_body: '{actor} علّق على منشورك',
        new_comment: 'تعليق جديد',
        new_comment_body: '{actor} علّق على المنافسة',
        new_join_request_body: '{actor}: {preview}',
        competition_invite: 'دعوة لمنافسة',
        competition_invite_body: '{actor}: {preview}',
        // R2-J: عنوان قبول الدعوة — مستقل عن طلب الانضمام الجديد
        invitation_accepted: 'تم قبول دعوتك',
        new_rating: 'تقييم جديد',
        new_rating_body: '{actor} قيّم المنافسة',
        system_notice: 'إشعار من النظام',
        generic: 'لديك إشعار جديد',
        // R4-EVENTS-NOTIFY-1 (N-05/M-5): تسميتا زر النجمة في القائمة.
        star: 'تمييز بنجمة',
        unstar: 'إلغاء التمييز',
        // F-7: إشعارات دورة حياة المنافسات — كل النصوص user-facing عبر i18n
        comp_deleted_title: 'تم حذف المنافسة',
        comp_deleted: 'تم حذف المنافسة الفورية لأنه لم ينضم منافس خلال ساعة.',
        comp_cancelled: 'تم إلغاء المنافسة',
        comp_cancelled_no_opponent: 'تم إلغاء منافستك المجدولة لأنه لم ينضم منافس خلال ساعة من الموعد المحدد.',
        comp_cancelled_not_started: 'تم إلغاء المنافسة المجدولة لأنها لم تبدأ خلال ساعة من الموعد المحدد.',
        comp_cancelled_generic: 'تم إلغاء المنافسة لأنها لم تبدأ في الوقت المحدد.',
        comp_ended_title: 'انتهت المنافسة',
        comp_ended: 'انتهت المنافسة المباشرة تلقائيًا بعد الوصول إلى الحد الأقصى لمدة ساعتين.',
        comp_reminder_title: 'تذكير بالمنافسة',
        comp_reminder: 'ستبدأ المنافسة قريبًا!',
    },

    // الرسائل
    messages: {
        title: 'الرسائل',
        select_conversation: 'اختر محادثة',
        no_conversations: 'لا توجد محادثات',
        no_messages: 'لا توجد رسائل',
        type_message: 'اكتب رسالة...',
        enter_message: 'أدخل رسالتك',
        back_to_conversations: 'العودة إلى المحادثات',
        back_to_admin_messages: 'العودة إلى رسائل الإدارة',
        send: 'إرسال',
        send_failed: 'تعذّر إرسال الرسالة. حاول مرة أخرى.',
        sending: 'جاري الإرسال...',
        composer_hint: 'Enter للإرسال · Shift+Enter لسطر جديد',
        new_conversation: 'محادثة جديدة',
        load_failed: 'تعذّر تحميل الرسائل',
    },

    // R2-M (H6): محادثات الدعم / صندوق الإدارة
    support: {
        personal_tab: 'المحادثات',
        admin_tab: 'رسائل الإدارة',
        official_sender: 'دعم Dueli',
        new_thread: 'رسالة جديدة للإدارة',
        subject_label: 'الموضوع (اختياري)',
        no_threads: 'لا توجد رسائل إدارية',
        select_thread: 'اختر رسالة',
        thread_closed: 'هذه المحادثة مغلقة',
        admin_inbox: 'صندوق الدعم',
        reply_label: 'رد رسمي',
        close_thread: 'إغلاق المحادثة',
        reopen_thread: 'إعادة فتح المحادثة',
        unread_admin: 'رسائل إدارية غير مقروءة',
    },

    // رسائل أخطاء الرسائل (تستخدم بواسطة MessageController)
    message: {
        invalid_recipient: 'المستلم غير صالح',
        content_required: 'محتوى الرسالة مطلوب',
    },

    // الإعدادات
    settings_page: {
        title: 'الإعدادات',
        language: 'اللغة الافتراضية',
        country: 'البلد الافتراضي',
        privacy: 'خصوصية الملف',
        privacy_public: 'عام',
        privacy_followers: 'المتابعين فقط',
        privacy_private: 'خاص',
        notifications: 'تفعيل الإشعارات',
        email_notifications: 'إشعارات البريد',
        push_notifications: 'إشعارات الدفع',
        save: 'حفظ الإعدادات',
        saved: 'تم حفظ الإعدادات',
        password_section: 'كلمة المرور',
        password_current: 'كلمة المرور الحالية',
        password_new: 'كلمة المرور الجديدة',
        password_confirm: 'تأكيد كلمة المرور الجديدة',
        password_change_submit: 'تحديث كلمة المرور',
        password_confirm_mismatch: 'كلمة المرور الجديدة والتأكيد غير متطابقين',
        password_social_hint: 'هذا الحساب مسجل عبر المصادقة الاجتماعية. سجّل الدخول عبر مزوّدك، أو أعد تعيين كلمة المرور لتفعيل الدخول بالبريد.',
        password_reset_cta: 'إعادة تعيين كلمة المرور بالبريد',
    },
    profile_competitions: {
        load_more: 'عرض المزيد من المنافسات',
        delete_action: 'حذف المنافسة',
        delete_confirm_title: 'حذف هذه المنافسة؟',
        delete_confirm_body: 'سيتم حذف «{title}» نهائيًا ولا يمكن التراجع.',
        delete_success: 'تم حذف المنافسة',
        delete_failed: 'تعذّر حذف المنافسة',
        delete_in_progress: 'جارٍ الحذف…',
    },

    // البلاغات
    report: {
        title: 'إبلاغ',
        reason: 'السبب',
        select_reason: 'اختر سبباً',
        target_type: 'نوع الهدف',
        select_target_type: 'اختر نوع الهدف',
        target_id: 'معرّف الهدف',
        target_id_placeholder: 'رقم المستخدم أو المنافسة أو التعليق',
        description: 'تفاصيل إضافية',
        description_placeholder: 'قدم مزيداً من التفاصيل...',
        submit: 'إرسال البلاغ',
        submitted: 'تم إرسال البلاغ',
        already_reported: 'قمت بالإبلاغ مسبقاً',
        reason_spam: 'بريد مزعج',
        reason_harassment: 'مضايقة',
        reason_fake_account: 'حساب مزيف',
        reason_inappropriate_content: 'محتوى غير لائق',
        reason_misleading: 'مضلل',
        reason_copyright: 'انتهاك حقوق النشر',
        reason_hate_speech: 'خطاب كراهية',
        reason_other: 'أخرى',
    },

    // الجدولة
    schedule: {
        title: 'جدولي',
        reminders: 'التذكيرات',
        upcoming: 'المنافسات القادمة',
        empty: 'لا توجد منافسات مجدولة',
        creator: 'منشئ',
        add_reminder: 'تعيين تذكير',
        remove_reminder: 'إزالة التذكير',
        reminder_set: 'تم تعيين التذكير!',
        reminder_removed: 'تم إزالة التذكير',
        not_scheduled: 'المنافسة غير مجدولة',
        not_eligible: 'التذكير غير متاح لهذه حالة المنافسة',
        already_set: 'التذكير موجود مسبقاً',
        not_found: 'التذكير غير موجود',
    },

    // الإعجابات
    like: {
        title: 'الإعجابات',
        already_liked: 'أعجبت بها مسبقاً',
        not_found: 'الإعجاب غير موجود',
    },

    // عدم الإعجاب (B8)
    interactions: {
        dislike: 'عدم الإعجاب',
        undislike: 'إلغاء عدم الإعجاب',
        dislikes_count: 'عدد عدم الإعجاب',
        dislike_not_found: 'عدم الإعجاب غير موجود',
    },

    // المنشورات
    post: {
        content_required: 'محتوى المنشور مطلوب',
        created: 'تم إنشاء المنشور',
        deleted: 'تم حذف المنشور',
    },

    // المصادقة (متداخلة للاستخدام في العميل)
    auth: {
        login_success: 'تم تسجيل الدخول بنجاح!',
        logout_success: 'تم تسجيل الخروج بنجاح',
        connection_failed: 'فشل الاتصال. يرجى المحاولة مرة أخرى.',
    },

    // رسائل العميل
    client: {
        toast: {
            welcome: 'مرحباً بعودتك!',
            allow_popups: 'يرجى السماح بالنوافذ المنبثقة لتسجيل الدخول',
        },
    },

    // البحث
    search: {
        no_results: 'لا توجد نتائج',
    },

    // R3-D1 (h7-v1): المفضلات الصريحة للاهتمامات (اختيارية من الإعدادات)
    favorites: {
        title: 'الأقسام المفضلة',
        hint: 'اختر الأقسام والفروع التي تهمك لتحسين التوصيات (اختياري)',
        saved: 'حُفظت المفضلات',
        empty: 'لم تختر مفضلات بعد — ستظهر لك التوصيات العامة',
    },
    similar: {
        title: 'منافسات مشابهة',
    },

    // UNIT32.1 (R4-PROFILE-COLLECTIONS-1): قوائم صاحب البروفايل
    watch_collections: {
        title: 'قوائمي',
        hint: 'منافساتك المحفوظة وسجل مشاهداتك — تظهر لك وحدك.',
        tab_later: 'المشاهدة لاحقًا',
        tab_history: 'سجل المشاهدات',
        add: 'حفظ في المشاهدة لاحقًا',
        remove: 'إزالة من المشاهدة لاحقًا',
        added: 'أُضيفت إلى المشاهدة لاحقًا',
        removed: 'أُزيلت من المشاهدة لاحقًا',
        save_failed: 'تعذّر تحديث المشاهدة لاحقًا. حاول مرة أخرى.',
        loading: 'جارٍ التحميل…',
        empty_later: 'لم تحفظ أي منافسة بعد. استخدم أيقونة الحفظ على أي بطاقة.',
        empty_history: 'لا يوجد سجل مشاهدات بعد. تظهر هنا المنافسات التي تشاهدها فعليًا.',
        error: 'تعذّر تحميل القائمة.',
        retry: 'إعادة المحاولة',
        load_more: 'تحميل المزيد',
        history_hint: 'الأحدث أولًا — تُسجَّل المشاهدة أثناء التشغيل الفعلي فقط.',
        watched_for: 'مدة المشاهدة',
        less_than_minute: 'أقل من دقيقة',
        minutes_short: 'د',
    },

    // صفحة الملف الشخصي (جديد)
    wins: 'انتصارات',
    posts: 'منشورات',
    no_competitions: 'لا توجد منافسات بعد',
    no_posts: 'لا توجد منشورات بعد',
    edit_profile: 'تعديل الملف الشخصي',
    send_message: 'رسالة',

    // حالة المنافسة (جديد)
    completed: 'مكتملة',
    view: 'عرض',
    confirm_delete: 'هل أنت متأكد من الحذف؟',

    // الطلبات (جديد)
    received_requests: 'المستلمة',
    sent_requests: 'المرسلة',
    no_requests: 'لا توجد طلبات بعد',
    wants_to_join: 'يريد الانضمام لمنافستك',
    you_requested: 'طلبت الانضمام إلى',
    invitations: 'الدعوات',
    invites_you: 'يدعوك للمنافسة',

    // أزرار التفاعل (جديد)
    remind_me: 'ذكرني',
    reminder_added: 'تم إضافة التذكير!',
    report_inappropriate: 'محتوى غير لائق',
    report_spam: 'بريد مزعج أو مضلل',
    report_harassment: 'تحرش أو تنمر',
    report_submitted: 'تم إرسال البلاغ. شكراً لك!',
    select_reason: 'الرجاء اختيار سبب',

    // البث المباشر / Jitsi (جديد)
    jitsi_not_configured: 'لم يتم إعداد خدمة البث المباشر بعد.',
    confirm_end_call: 'هل أنت متأكد من إنهاء المكالمة؟',

    // البث المباشر (P2P)
    recording: 'جاري التسجيل',
    toggle_mic: 'افتح/أغلق المايك',
    toggle_speaker: 'افتح/أغلق الصوت',
    toggle_camera: 'افتح/أغلق الكاميرا',
    share_screen: 'مشاركة الشاشة',
    end_stream: 'إنهاء البث',
    end_stream_confirm: 'هل أنت متأكد من إنهاء البث؟',
    join_stream: 'انضم للبث',
    you_are_host: 'أنت المضيف',
    you_are_guest: 'أنت الضيف',
    end: 'إنهاء',
    you: 'أنت',
    opponent: 'الخصم',
    waiting_opponent: 'في انتظار الخصم...',
    chunks_uploaded: 'قطعة تم رفعها',
    camera_error: 'فشل في الوصول للكاميرا أو الميكروفون',
    hls_not_supported: 'متصفحك لا يدعم تشغيل HLS',
    return_to_live: 'عودة للبث',
    live_rewind: 'إرجاع مقطع واحد',
    // R4-CHUNK-VIEW-RECOVERY-1 REM1 (28.4.1): audience player states + replay
    replay: 'إعادة',
    live_timeline: 'الخط الزمني للبث',
    player_state_waiting: 'في انتظار البث...',
    player_state_playing: 'قيد التشغيل',
    player_state_processing: 'جارٍ تجهيز التسجيل...',
    player_state_error: 'تعذّر تشغيل الوسائط',
    player_state_ready: 'جاهز للتشغيل',
    player_state_unavailable: 'الوسائط غير متاحة',
    live_comments: 'ستظهر التعليقات المباشرة هنا...',
    fullscreen: 'ملء الشاشة',
    exit_fullscreen: 'الخروج من ملء الشاشة',
    swap_videos: 'تبديل الفيديوهات',
    toggle_comments: 'إظهار/إخفاء التعليقات',
    toggle_my_video: 'إظهار/إخفاء صورتي',
    switch_camera: 'تبديل الكاميرا',
    close_ad: 'إغلاق الإعلان',
    report_ad: 'الإبلاغ عن الإعلان',
    ad: 'إعلان',
    clear_data: 'مسح بيانات الموقع',
    viewers_cannot_close_ads: 'المشاهدون لا يمكنهم إغلاق الإعلانات',
    report_ad_confirm: 'الإبلاغ عن هذا الإعلان كمحتوى غير لائق؟',
    ad_reported: 'تم الإبلاغ عن الإعلان. شكراً لك!',
    // R4-LIVE-ENTRY-RECOVERY-1: الاستعداد الخاص وبوابة الموافقة الصريحة
    prep_privacy_hint: 'صوتك وصورتك لا يُرسلان حتى تضغط على زر النشر. هذه معاينة محلية فقط.',
    prep_publish_host: 'ابدأ البث',
    prep_publish_guest: 'انشر وانضم',
    prep_publishing: 'جارٍ النشر...',
    prep_starting: 'جارٍ بدء المنافسة...',
    prep_ending: 'جارٍ إنهاء المنافسة...',
    prep_verifying_end: 'جارٍ التحقق من نتيجة الإنهاء...',
    end_competition_failed: 'تعذّر إنهاء المنافسة. ما زالت متاحة لإعادة المحاولة.',
    video_layout_waiting: 'بانتظار فيديو الخصم — معاينتك المحلية في المساحة الكبيرة',
    video_layout_remote: 'فيديو الخصم كبير — معاينتك في النافذة الصغيرة',
    video_layout_lost: 'انقطع فيديو الخصم — عادت معاينتك إلى المساحة الكبيرة',
    video_layout_terminal: 'انتهت المنافسة',
    prep_published: 'تم النشر — الوسائط الآن على الهواء',
    prep_waiting_host: 'بانتظار انضمام الخصم...',
    prep_waiting_guest: 'بانتظار بدء المضيف...',
    // R4-LIVE-ENTRY-RECOVERY-REM1: honest prep/publish + leave/stage controls
    live_tools: 'أدوات البث',
    start_competition: 'بدء المنافسة',
    start_competition_failed: 'تعذّر بدء المنافسة',
    publish_state_off: 'لم تُنشر وسائطك — هذه معاينة محلية فقط',
    publish_state_on: 'أنت تنشر الآن — وسائطك تصل إلى الطرف الآخر',
    nothing_to_publish: 'لا توجد وسائط للنشر. اسمح بالكاميرا أو الميكروفون أو شارك الشاشة أولاً.',
    media_none: 'لا توجد كاميرا أو ميكروفون. يمكنك مشاركة الشاشة للاستعداد.',
    waiting_peer_media: 'بانتظار وسائط الطرف الآخر...',
    screen_share_stopped: 'تم إيقاف مشاركة الشاشة.',
    end_competition: 'إنهاء المنافسة',
    end_competition_confirm: 'هل أنت متأكد من إنهاء المنافسة للجميع؟',
    early_end_confirm: 'إنهاء مبكر: ستعتمد كمنسحب وتخسر المنافسة. سيفوز الخصم بالانسحاب ويحصل على رصيد نظامي 10 نجوم (تقييمان بخمس نجوم)، وستحصل أنت على 0، وتُحسب جودة المنافسة القصيرة 0. هل تريد المتابعة؟',
    early_end_winner_banner: 'فوز بالانسحاب المبكر',
    early_end_result_note: 'رصيد نظامي منفصل عن أصوات الجمهور: 10 نجوم للخصم و0 للمنهي.',
    fullscreen_unavailable: 'ملء الشاشة غير متاح هنا؛ تم استخدام العرض الموسع داخل الصفحة.',
    expand_stage: 'تكبير المسرح',
    collapse_stage: 'تصغير المسرح',

    // التنقل (جديد)
    notifications: 'الإشعارات',
    mark_all_read: 'تعليم الكل كمقروء',
    no_messages: 'لا توجد رسائل',
    earnings_nav: 'الأرباح',
    donate: 'دعم المنصة',
    contact_admin: 'مراسلة الإدارة',
    submit_report: 'تقديم شكوى',
    no_notifications: 'لا توجد إشعارات',

    // صفحة الإشعارات (قبول ما بعد R1: مسار /notifications)
    notifications_page: {
        mark_read: 'تعليم كمقروء',
    },

    // صفحة الأرباح
    available: 'متاح',
    pending: 'قيد المعالجة',
    on_hold: 'معلق',
    ad_revenue: 'عائدات الإعلانات',
    total_earnings: 'إجمالي الأرباح',
    from_competitions: 'من المنافسات',
    withdrawn: 'تم سحبه',
    to_bank: 'إلى الحساب البنكي',
    withdraw: 'سحب',
    min_withdrawal: 'الحد الأدنى للسحب: 50 دولار',
    request_withdrawal: 'طلب سحب',
    withdrawal_history: 'سجل السحوبات',
    no_withdrawal_history: 'لا يوجد سجل سحوبات بعد',
    submit_withdrawal: 'إرسال طلب السحب',
    withdrawal_submitted: 'تم إرسال طلب السحب!',
    withdrawal_approved: 'تمت الموافقة على طلب السحب!',
    withdrawal_rejected: 'تم رفض طلب السحب: ',
    withdrawal_cancelled: 'تم إلغاء طلب السحب وإعادة الرصيد.',
    confirm_cancel_withdrawal: 'إلغاء طلب السحب هذا؟ سيُعاد المبلغ إلى رصيدك.',
    amount: 'المبلغ',
    payment_method: 'طريقة الدفع',
    bank_transfer: 'تحويل بنكي',
    payment_details: 'بيانات الدفع',
    payment_details_placeholder: 'IBAN / بريد Wise / عنوان المحفظة...',
    payment_details_required: 'بيانات الدفع مطلوبة.',
    processing: 'جارٍ المعالجة...',
    network_error: 'خطأ في الشبكة. يرجى المحاولة مرة أخرى.',
    // Nested earnings keys for earnings split components (8.B)
    earnings: {
        total: 'الإجمالي',
        pending: 'قيد الانتظار',
        per_competition: 'لكل منافسة',
    },

    // المحفظة (دفتر الأستاذ 8.A)
    wallet: {
        balance: 'رصيد المحفظة',
        insufficient_funds: 'الرصيد غير كافٍ لإتمام هذه العملية',
        transaction_failed: 'فشلت عملية المحفظة — يرجى المحاولة مرة أخرى',
    },

    // المدفوعات — تكامل Stripe مع دفتر الأستاذ (8.C)
    payment_min_amount: 'الحد الأدنى لمبلغ التبرع هو 1 دولار',
    payment_method_invalid: 'طريقة الدفع غير صالحة',
    payment_failed: 'فشل بدء عملية الدفع — يرجى المحاولة لاحقاً',
    payment_success: 'تمت عملية الدفع بنجاح',
    payment_cancelled: 'تم إلغاء عملية الدفع',
    donation_completed: 'شكراً لك — اكتمل تبرعك',
    donation_failed: 'لم تكتمل عملية التبرع',
    donation_refunded: 'تم استرداد مبلغ هذا التبرع',

    // السحوبات — دورة الحياة الموثقة (8.D): requested → approved → paid | rejected
    withdrawals: {
        requested: 'طلب سحب جديد بانتظار مراجعة الإدارة',
        approved: 'تمت الموافقة على طلب السحب من الإدارة',
        rejected: 'تم رفض طلب السحب وأُعيد المبلغ المحجوز إلى رصيدك',
        min_amount: 'الحد الأدنى لمبلغ السحب هو 50 دولاراً',
        insufficient_balance: 'رصيدك المتاح لا يكفي مبلغ السحب المطلوب',
    },

    // R2-P: طرق الدفع المحفوظة + لقطات السحب
    payout: {
        type_invalid: 'النوع الصالح مطلوب: bank أو paypal أو wise',
        bank_fields_required: 'IBAN واسم البنك مطلوبان للحسابات البنكية',
        email_required: 'البريد الإلكتروني مطلوب لـPayPal/Wise',
        method_not_found: 'طريقة الدفع غير موجودة',
        saved_methods: 'طرق الدفع المحفوظة',
        use_saved_method: 'استخدام طريقة محفوظة',
        manual_entry: 'إدخال التفاصيل يدوياً',
        no_saved_methods: 'لا توجد طرق دفع محفوظة بعد',
    },

    // التبرعات للمتنافسين (8.E) — الحد الأدنى $1 موثق، ولا حد أقصى على مستوى Dueli
    // 8.G-F3 — التبرعات غير قابلة للاسترداد بعد إتمامها (انظر docs/02-DATABASE.md)
    donations: {
        send: 'إرسال التبرع',
        thanks: 'شكراً لدعمك المتنافس!',
        min: 'الحد الأدنى للتبرع هو دولار واحد',
        max: 'لا يفرض Dueli حداً أقصى للتبرع',
        blocked: 'لا يمكنك التبرع لمستخدم قام بحظرك',
        invalid_competition: 'التبرع أثناء البث يتطلب منافسة live ومتنافساً فيها',
        non_refundable: 'التبرع غير قابل للاسترداد بعد إتمامه',
        non_refundable_accept: 'أفهم وأوافق على أن هذا التبرع غير قابل للاسترداد',
        non_refundable_required: 'يجب الموافقة على أن التبرع غير قابل للاسترداد',
        amount_confirm: 'أؤكد مبلغ هذا التبرع',
        amount_confirm_required: 'يجب تأكيد مبلغ التبرع',
        be_first: 'كن أول الداعمين!',
        my_donations: 'تبرعاتي',
        my_donations_empty: 'لم تتبرع بعد',
        my_donations_error: 'تعذر تحميل تبرعاتك',
    },

    // صفحة الشكاوى
    report_type: 'نوع البلاغ',
    report_inappropriate_desc: 'محتوى مسيء أو ضار',
    report_spam_desc: 'محتوى مزيف أو مضلل',
    report_harassment_desc: 'استهداف أو مهاجمة الآخرين',
    other: 'أخرى',
    other_desc: 'شيء آخر',
    subject: 'الموضوع',
    description: 'الوصف',
    enter_subject: 'أدخل الموضوع',
    describe_issue: 'يرجى وصف المشكلة بالتفصيل',

    // صفحة الدعم
    support_dueli: 'ادعم ديولي',
    support_message: 'ساعدنا في بناء منصة أفضل للحوارات والتواصل الهادف.',
    coffee: 'اشترِ لنا قهوة',
    supporter: 'داعم',
    champion: 'بطل',
    custom_amount: 'أو أدخل مبلغاً مخصصاً',
    donate_now: 'تبرع الآن',
    popular: 'الأكثر شيوعاً',
    top_supporters: 'أبرز الداعمين',

    // صفحات اختبار البث
    test_stream: 'اختبار البث',
    test_stream_desc: 'اختبار البث - WebRTC + Canvas + Upload',
    host: 'المضيف',
    host_desc: 'يبدأ البث ويشارك الشاشة',
    guest: 'الضيف',
    guest_desc: 'ينضم للبث كمنافس',
    viewer: 'المشاهد',
    viewer_desc: 'يشاهد البث مباشر أو مسجل',
    screen_share: 'مشاركة الشاشة',
    canvas_recording: 'تسجيل Canvas',
    new_chunk: 'قطعة جديدة',
    upload_chunks: 'رفع القطع',
    adaptive_streaming: 'بث متكيف',
    notes: 'ملاحظات',
    test_note_1: 'الصفحات الثلاث تستخدم core.ts المشترك',
    test_note_2: 'Host يسجل Canvas ويرفع chunks',
    test_note_3: 'Guest يشارك شاشته ويجيب على Offer',
    test_note_4: 'Viewer مشغل ذكي مع Adaptive polling',
    competition_number: 'رقم المنافسة',
    enter_number: 'أدخل الرقم',
    initializing: 'جاري التهيئة...',
    enter_comp_id_to_join: 'أدخل رقم المنافسة ثم اضغط الانضمام',
    share_then_join: 'اضغط "مشاركة الشاشة" ثم "الانضمام"',
    quality: 'الجودة',
    determining: 'جاري التحديد...',
    waiting: 'انتظار...',
    mode: 'الوضع',
    chunks: 'القطع',
    buffer: 'Buffer',
    enter_comp_to_watch: 'أدخل رقم المنافسة لبدء المشاهدة',
    smart_viewer: 'مشاهد ذكي: HLS أولاً، MSE احتياطي',
    start_watching: 'شاهد',
    stop_watching: 'إيقاف',
    reconnect: 'إعادة الاتصال',
    reconnecting: 'جاري استعادة الاتصال...',
    reconnected: 'تمت استعادة الاتصال',
    reconnect_failed: 'تعذّرت استعادة الاتصال',
    connect: 'اتصال',
    join: 'الانضمام',
    disconnect: 'إنهاء',
    download: 'تحميل',
    converting: 'جاري التحويل',
    page_loaded: 'تم تحميل الصفحة',

    // R4-CHUNK-DOWNLOAD-1: تنزيل مستقل للنسخة المسجلة بصيغة MP4
    download_ui: {
        title: 'تنزيل التسجيل',
        close: 'إغلاق',
        start: 'تنزيل MP4',
        start_partial: 'تنزيل المقطع المتاح',
        cancel: 'إلغاء',
        retry: 'إعادة المحاولة',
        save_again: 'حفظ مرة أخرى',
        loading_manifest: 'جارٍ قراءة بيان التسجيل المعتمد من الخادم…',
        analyzing: 'جارٍ التحقق من القطع والمدة والذاكرة المتاحة…',
        complete_label: 'تسجيل كامل',
        partial_label: 'مقطع جزئي',
        rights_competitor: 'أنت أحد المتنافسين في هذه المنافسة. يحق لك إعادة نشر مادة منافستك أو تحقيق الدخل منها.',
        rights_viewer: 'تحتاج إلى إذن من المنصة لإعادة نشر هذا التسجيل. المشاهدة الشخصية مسموحة.',
        meta_size: 'الحجم',
        meta_duration: 'المدة',
        meta_chunks: 'القطع',
        meta_mode: 'المعالجة',
        mode_mp4_remux: 'إعادة تجميع MP4 (دون إعادة ترميز)',
        mode_ffmpeg: 'تحويل إلى MP4 (H.264/AAC)',
        mode_none: 'غير متاح',
        partial_notice: 'هذا التسجيل غير مكتمل أو غير نهائي. يمكنك تنزيل القطع الجاهزة المتاحة الآن كمقطع جزئي موسوم بوضوح.',
        resource_note: 'تتم المعالجة داخل متصفحك بالكامل. نسخة المتصفح من FFmpeg تعمل بحد أقصى مقاس للذاكرة يبلغ 2 غيبيبايت، وتحتاج كذلك إلى ذاكرة للقطع الداخلة والملف الناتج. قد تتجاوز التسجيلات الطويلة جداً ذاكرة الجهاز؛ عندها يتوقف التطبيق برسالة واضحة بدلاً من إنتاج ملف ناقص.',
        progress_fetching: 'جارٍ تنزيل القطع',
        progress_preparing: 'جارٍ تجهيز المحوّل',
        progress_assembling: 'جارٍ تجميع MP4',
        progress_converting: 'جارٍ التحويل إلى MP4',
        progress_finalizing: 'جارٍ التحقق من الملف',
        progress_done: 'تم',
        success: 'ملف MP4 جاهز: {size}، {duration}.',
        success_partial: 'ملف MP4 الجزئي جاهز: {size}، {duration}. هذا ليس التسجيل الكامل.',
        cancelled: 'تم إلغاء التنزيل. لم يُحفظ أي ملف.',
        cancelled_cleanup: 'تم تحرير القطع المؤقتة وذاكرة العامل وروابط الكائنات.',
        error_manifest: 'تعذّر تحميل بيان التنزيل.',
        error_not_authenticated: 'سجّل الدخول لتنزيل التسجيل.',
        error_no_chunks: 'لا توجد قطع تسجيل جاهزة بعد.',
        error_not_finalized: 'لم يتم إنهاء التسجيل بعد.',
        error_unsupported_format: 'صيغة التسجيل لا تسمح بالتنزيل.',
        error_duration_unknown: 'المدة المتحقق منها غير متاحة، لذا لا يمكن إنتاج MP4 صالح.',
        error_truncated: 'تجاوز بيان التسجيل الحد الآمن للقراءة.',
        error_heap_limit: 'الذاكرة التقديرية للمعالجة تتجاوز حد ذاكرة FFmpeg في المتصفح.',
        error_chunk_fetch: 'تعذّر تنزيل إحدى القطع بعد عدة محاولات.',
        error_chunk_integrity: 'فشل التحقق من حجم إحدى القطع أو بصمتها.',
        error_assembly: 'تعذّر تجميع بنية MP4 بأمان.',
        error_ffmpeg_unavailable: 'تعذّر تحميل عامل FFmpeg المستضاف على النطاق نفسه. تحقّق من الاتصال ودعم سياسة أمن المحتوى ثم أعد المحاولة.',
        error_ffmpeg: 'فشل المحوّل في المتصفح قبل إنتاج ملف MP4 صالح.',
        error_output_validation: 'فشل ملف MP4 الناتج في اختبار التشغيل أو المدة أو التقديم، لذلك لم يُحفظ.',
        error_unknown: 'فشل التنزيل لسبب غير متوقع.',
        error_detail: 'التفاصيل التقنية',
        aria_dialog: 'تنزيل التسجيل',
        aria_progress: 'تقدم التنزيل',
        language_note: 'الملف MP4 قياسي (H.264/AAC عند الحاجة إلى التحويل).',
    },

    // ── المهمة 4: محرك الشفافية ────────────────────────────────
    transparency: {
        // 8.F: شفافية الأموال من دفتر الأستاذ (مجاميع عامة + تحقق)
        total_in: 'إجمالي الداخل',
        total_out: 'إجمالي الخارج',
        platform_share: 'حصة المنصة',
        verified_at: 'وقت التحقق',
        page_title: 'دفتر الشفافية',
        page_subtitle: 'عرض مفتوح لكل دولار يتدفق عبر منصة ديولي.',
        nav_link: 'الشفافية',
        hero_badge: 'سياسة الكتاب المفتوح',
        last_audit: 'آخر تدقيق',
        audit_balanced: 'الدفاتر متوازنة ✓',
        audit_imbalanced: 'تم رصد خلل في الدفاتر ⚠',
        audit_discrepancy: 'الفارق',

        kpi_total_revenue: 'إجمالي إيرادات الإعلانات',
        kpi_platform_share: 'حصة المنصة المحتجزة',
        kpi_competitors_paid: 'مدفوعات المتنافسين',
        kpi_operating_costs: 'التكاليف التشغيلية',
        kpi_donations_in: 'التبرعات الواردة',
        kpi_net_platform: 'صافي المنصة (اليوم)',

        section_equation: 'معادلة المحاسبة',
        section_daily: 'الاتجاه المالي اليومي',
        section_financial_feed: 'سجل العمليات المالية',
        section_donation_feed: 'دفتر التبرعات',
        section_payroll: 'تفصيل الرواتب',
        section_admin_log: 'تدخلات الإدارة',
        section_top_donors: 'قاعة مشاهير الداعمين',

        eq_ad_revenue: 'إيرادات الإعلانات',
        eq_minus: '−',
        eq_operating_costs: 'التكاليف التشغيلية',
        eq_minus_donors: '− تمويل المتبرعين',
        eq_equals: '=',
        eq_platform_net: 'صافي المنصة',
        eq_plus: '+',
        eq_competitor_payouts: 'مدفوعات المتنافسين',

        th_date: 'التاريخ',
        th_type: 'نوع القيد',
        th_amount: 'المبلغ (USD)',
        th_description: 'الوصف',
        th_role: 'الدور',
        th_action: 'الإجراء',
        th_target: 'الهدف',
        th_donor: 'المتبرع',
        th_total_donated: 'إجمالي التبرعات',
        th_entries: 'العمليات',

        type_ad_revenue: 'إيراد إعلاني',
        type_competitor_payout: 'مدفوعات متنافس',
        type_platform_share: 'حصة المنصة',
        type_server_cost: 'تكلفة خوادم',
        type_developer_salary: 'راتب مطور',
        type_admin_salary: 'راتب إداري',
        type_donor_allocation: 'توظيف تبرعات',
        type_other_cost: 'تكلفة أخرى',
        type_donation_received: 'تبرع وارد',
        type_donation_allocated: 'تبرع موظَّف',

        load_more: 'تحميل المزيد',
        no_entries: 'لا توجد قيود بعد.',
        anonymous_donor: 'مجهول',
        verified_label: 'منصة شفافة موثقة',
        updated_live: 'البيانات تُحدَّث مباشرةً من الدفاتر',
        payroll_note: 'تفاصيل الرواتب الفردية سرية. الأرقام الإجمالية فقط.',
        admin_note: 'هويات المشرفين مجهولة. التسميات الوظيفية فقط.',
    },

    // ── المهمة 1: بوابة المعلنين ────────────────────────────────
    advertiser: {
        portal_title: 'بوابة المعلنين',
        dashboard: 'لوحة القيادة',
        my_campaigns: 'حملاتي الإعلانية',
        create_campaign: 'إنشاء حملة إعلانية',
        campaign_title: 'عنوان الحملة',
        budget: 'الميزانية',
        budget_remaining: 'الميزانية المتبقية',
        target_language: 'اللغة المستهدفة',
        target_country: 'البلد المستهدف',
        revenue_per_view: 'العائد لكل مشاهدة',
        impressions: 'المشاهدات',
        clicks: 'النقرات',
        spend: 'إجمالي الإنفاق',
        ctr: 'نسبة النقر',
        status_active: 'نشطة',
        status_paused: 'متوقفة',
        status_depleted: 'نفدت الميزانية',
        status_archived: 'مؤرشفة',
        pause_campaign: 'إيقاف الحملة',
        resume_campaign: 'استئناف الحملة',
        analytics: 'التحليلات',
        total_budget: 'إجمالي الميزانية',
        total_remaining: 'إجمالي المتبقي',
        active_campaigns: 'الحملات النشطة',
        no_campaigns: 'لا توجد حملات بعد. أنشئ حملتك الأولى!',
        campaign_created: 'تم إنشاء الحملة بنجاح',
        campaign_paused: 'تم إيقاف الحملة',
        campaign_resumed: 'تم استئناف الحملة',
        budget_exhausted: 'نفدت الميزانية',
        media_url: 'رابط الوسائط',
        media_kind: 'نوع الوسائط',
        media_image: 'صورة',
        media_gif: 'صورة متحركة GIF',
        media_video: 'فيديو',
        duration_sec: 'مدة الفيديو (ثانية)',
        duration_hint: 'مثال: 15',
        image_url: 'رابط الصورة',
        link_url: 'رابط الوجهة',
        budget_cents_label: 'الميزانية (سنت)',
        cost_cents_label: 'تكلفة العرض (سنت)',
        submitted_review: 'أُرسلت الحملة للمراجعة',
        campaign_ended: 'انتهت الحملة',
        submit_for_review: 'إرسال للمراجعة',
        end_campaign: 'إنهاء الحملة',
        not_your_campaign: 'هذه الحملة مملوكة لمعلن آخر',
    },

    // ── المرحلة 9.A: دورة حياة الحملة الإعلانية ─────────────────
    ads: {
        campaign_status_draft: 'مسودة',
        campaign_status_pending_review: 'بانتظار المراجعة',
        campaign_status_active: 'نشطة',
        campaign_status_paused: 'متوقفة مؤقتاً',
        campaign_status_ended: 'منتهية',
        budget_exhausted: 'نفدت ميزانية الحملة — توقف العرض تلقائياً',
        pending_review: 'الحملة بانتظار مراجعة الإدارة ولا يمكن تنشيطها بعد',
        invalid_transition: 'انتقال غير مسموح لحالة الحملة',
        invalid_budget: 'الميزانية يجب أن تكون عدداً صحيحاً موجباً بالسنت',
        campaign_not_draft: 'يجب أن تكون الحملة في حالة مسودة لإرسالها للمراجعة',
        campaign_not_active: 'يجب أن تكون الحملة نشطة لهذا الإجراء',
        campaign_not_paused: 'يجب أن تكون الحملة متوقفة مؤقتاً لاستئنافها',
        // ── المرحلة 9.C: القياس ومكافحة الاحتيال ─────────────
        impressions: 'المشاهدات',
        clicks: 'النقرات',
        ctr: 'نسبة النقر',
        spend: 'الإنفاق',
        // ── المرحلة 9.B: عرض الإعلان واستهدافه ───────────────
        sponsored_label: 'إعلان',
        why_this_ad: 'لماذا أرى هذا الإعلان؟',
        hide_ad: 'إخفاء الإعلان',
        frequency_cap_reached: 'وصلت إلى الحد الأقصى لتكرار عرض هذا الإعلان',
        policy_title: 'التحكم بإعلانات منافساتي',
        policy_hint: 'اختر كيف تظهر إعلانات الطرف الثالث في منافساتك. إعلانات ديولي الرسمية لا تُحظر.',
        policy_auto: 'تلقائي',
        policy_allow: 'قائمة السماح',
        policy_manual: 'موافقة يدوية',
        policy_block: 'حظر إعلانات الطرف الثالث',
        policy_invalid: 'إعداد إعلان غير صالح',
        policy_saved: 'تم حفظ تفضيل الإعلانات',
        policy_grants_title: 'الإعلانات الموافق عليها',
        policy_grants_hint: 'في وضع الموافقة اليدوية تظهر فقط الإعلانات التي توافق عليها هنا. إعلانات ديولي الرسمية لا تحتاج موافقة.',
        policy_grants_empty: 'لا توجد إعلانات مدفوعة مؤهلة للموافقة حالياً',
        policy_grant: 'موافقة',
        policy_revoke: 'إلغاء الموافقة',
        policy_loading: 'جارٍ التحميل...',
        house_limit: 'الحد ثلاثة إعلانات رسمية نشطة',
        invalid_media: 'نوع الوسائط يجب أن يكون صورة أو GIF أو فيديو',
        invalid_duration: 'مدة الفيديو يجب أن تكون عدداً صحيحاً موجباً بالثواني',
    },

    // ── C7: تمييز البيانات الاصطناعية/التجريبية ─────────────
    demo: {
        badge: 'تجريبي',
        title: 'بيانات تجريبية لأغراض العرض — ليست حساباً أو منافسة حقيقية',
    },

    // ── المهمة 2: حوكمة الإدارة ──────────────────────────────────
    admin: {
        dashboard_title: 'لوحة تحكم المشرفين',
        enhanced_stats: 'إحصائيات متقدمة',
        admin_roles: 'أدوار المشرفين',
        grant_role: 'منح دور',
        revoke_role: 'إلغاء دور',
        role_superadmin: 'مشرف أعلى',
        role_auditor: 'مراجع',
        role_moderator: 'مشرف',
        invalid_role: 'الدور المحدد غير صالح',
        audit_logs: 'سجلات المراجعة',
        platform_settings: 'إعدادات المنصة',
        setting_key: 'مفتاح الإعداد',
        setting_value: 'قيمة الإعداد',
        update_setting: 'تحديث الإعداد',
        active_users: 'المستخدمون النشطون',
        demographics: 'التركيبة السكانية',
        hottest_competitions: 'أكثر المنافسات رواجاً',
        financial_summary: 'الملخص المالي',
        today_summary: 'ملخص اليوم',
        pending_arbitrations: 'التحكيمات المعلقة',
        active_campaigns: 'الحملات الإعلانية النشطة',
        competitions_by_status: 'المنافسات حسب الحالة',
        action_grant_role: 'منح دور',
        action_revoke_role: 'إلغاء دور',
        action_update_setting: 'تحديث إعداد',
        action_arbitration: 'إجراء تحكيم',
        action_finalize_payout: 'إنهاء المدفوعات',
        role_not_found: 'دور المشرف غير موجود',
        last_superadmin: 'لا يمكن إلغاء آخر مشرف أعلى',
        access_denied: 'يلزم صلاحية الإدارة',
        admin_panel: 'لوحة الإدارة',
        my_account: 'حسابي',
        ad_pricing_title: 'تسعير الإعلانات',
        ad_pricing_hint: 'اترك الحقول فارغة للحفاظ على تكلفة الحملة الحالية. كل مضاعف غير محدد يساوي 1.',
        country_base_cents: 'السعر الأساسي حسب البلد (سنت)',
        country_code: 'رمز البلد',
        base_cents: 'السنتات',
        h7_multiplier: 'مضاعف H7',
        targeting_multiplier: 'مضاعف الاستهداف',
        media_multipliers: 'مضاعفات الوسائط',
        duration_multipliers: 'مضاعفات مدة الفيديو (ثانية)',
        duration_seconds: 'الثواني',
        multiplier: 'المضاعف',
        add_row: 'إضافة صف',
        remove_row: 'حذف الصف',
        save_pricing: 'حفظ التسعير',
        clear_pricing: 'مسح التسعير',
        pricing_saved: 'تم حفظ التسعير',
        pricing_clear_confirm: 'مسح كل إعدادات التسعير والعودة إلى تكلفة الحملة؟',
        house_title: 'إعلان ديولي رسمي',
        house_hint: 'يظهر كبديل عندما لا يوجد إعلان مدفوع مؤهل. الحد الأقصى 3 إعلانات نشطة، ولا يمكن حظرها.',
        house_ad_title: 'عنوان الإعلان',
        house_create: 'إنشاء إعلان رسمي',
        house_created: 'تم إنشاء الإعلان الرسمي',
        media_url: 'رابط الوسائط',
        media_kind: 'نوع الوسائط',
        media_image: 'صورة',
        media_gif: 'GIF',
        media_video: 'فيديو',
        duration_sec: 'المدة (ثانية)',
        link_url: 'رابط الوجهة',
        save: 'حفظ',
        documents_title: 'الوثائق والبيانات',
        documents_empty: 'لا توجد وثائق بعد',
    },

    // ── R2-A: إعدادات الحساب الذاتية ──────────────
    account: {
        username_updated: 'تم تحديث اسم المستخدم',
        email_updated: 'تم تحديث البريد — يرجى توثيق العنوان الجديد',
        password_updated: 'تم تحديث كلمة المرور — يرجى تسجيل الدخول مجدداً',
        username_taken: 'اسم المستخدم مستخدم بالفعل',
        username_invalid: 'اسم المستخدم 3-30 حرفاً صغيراً أو أرقاماً أو نقاطاً أو شرطات سفلية',
        email_taken: 'البريد الإلكتروني مستخدم بالفعل',
        email_invalid: 'عنوان بريد غير صالح',
        current_password_incorrect: 'كلمة المرور الحالية غير صحيحة',
    },

    // ── R2-A (H9): الوثائق والبيانات المدارة ──────────────
    documents: {
        slug_invalid: 'المعرف 2-80 حرفاً صغيراً أو أرقاماً أو شرطات',
        slug_taken: 'توجد وثيقة بهذا المعرف مسبقاً',
        status_invalid: 'الحالة يجب أن تكون مسودة أو منشورة',
        visibility_invalid: 'الظهور يجب أن يكون خاصاً أو عاماً',
        created: 'تم إنشاء الوثيقة',
        updated: 'تم تحديث الوثيقة',
        deleted: 'تم حذف الوثيقة',
        draft: 'مسودة',
        published: 'منشورة',
        private: 'خاصة',
        public: 'عامة',
        preview: 'معاينة',
        save: 'حفظ',
        seed_badge: 'بيانات اختبار موسومة',
    },

    // ── المهمة 3: التحكيم والشكاوى ────────────────────────────────
    arbitration: {
        submit_complaint: 'تقديم شكوى',
        my_complaints: 'شكاواي',
        track_complaint: 'تتبع الشكوى',
        complaint_submitted: 'تم تقديم الشكوى بنجاح',
        status_submitted: 'مقدمة',
        status_under_review: 'قيد المراجعة',
        status_investigation: 'قيد التحقيق',
        status_resolved: 'تم الحل',
        status_rejected: 'مرفوضة',
        assigned_admin: 'المشرف المُعيَّن',
        admin_role: 'دور المشرف',
        state_history: 'سجل الحالات',
        transition_notes: 'ملاحظات الانتقال',
        no_complaints: 'لم تقدم أي شكاوى بعد',
        complaint_not_found: 'الشكوى غير موجودة',
        invalid_transition: 'انتقال حالة غير صالح',
        assign_to_admin: 'تعيين لمشرف',
        transition_state: 'تغيير الحالة',
        resolve: 'حل',
        reject: 'رفض',
        investigate: 'بدء التحقيق',
    },

    // ── المهمة 5: محرك المالية الحية ──────────────────────────────
    live_finance: {
        dashboard_title: 'لوحة المالية الحية',
        total_ad_revenue: 'إجمالي إيرادات الإعلانات',
        platform_cut: 'حصة المنصة',
        creator_payout: 'مدفوعات المنشئ',
        opponent_payout: 'مدفوعات الخصم',
        competitor_pool: 'مجموع المتنافسين',
        platform_percentage: 'نسبة حصة المنصة %',
        creator_rating: 'تقييم المنشئ',
        opponent_rating: 'تقييم الخصم',
        total_ratings: 'إجمالي التقييمات',
        finalize_payouts: 'إنهاء المدفوعات',
        payouts_finalized: 'تم إنهاء المدفوعات',
        live_numbers: 'أرقام حية',
        updating_realtime: 'يتم التحديث فورياً مع التصويت',
        revenue_split: 'تقسيم الإيرادات',
        competition_revenue: 'إيرادات المنافسة',
    },

    // ── T2.4: تقييم المشاهدين والفائز ──────────────
    rate_title: 'قيّم المنافسين',
    rate_thanks: 'شكراً لتقييمك!',
    rate_failed: 'فشل إرسال التقييم',
    rate_winner_banner: 'الفائز بتقييم الجمهور',

    // ── B11: ملخص التقييمات مجهول الهوية + السحب ──────────────
    // ── R2-V: حصيلة مؤقتة أثناء البث + نهائية للقراءة فقط بعد الإغلاق ──
    ratings: {
        summary_title: 'ملخص التقييمات',
        average: 'المتوسط',
        no_ratings: 'لا توجد تقييمات بعد',
        withdrawn: 'تم سحب تقييمك',
        live_provisional: 'حصيلة مؤقتة — تتحدث مباشرة أثناء البث',
        final_readonly: 'النتيجة النهائية — التقييم مغلق',
        not_eligible: 'شاهد 300 ثانية من البث لتتمكن من التقييم',
        update_rating: 'تحديث التقييم',
        withdraw_rating: 'سحب التقييم',
        unique_raters: 'مقيّمون فريدون',
        score_scale_hint: 'النتيجة من 5',
        draw_label: 'تعادل',
        zero_score: 'لا نتيجة بعد',
        live_awaiting: 'بانتظار تقييمات الجمهور',
        zero_completed: '—',
        early_withdrawal_closed: 'حُسمت المنافسة بالانسحاب المبكر قبل اكتمال تقييم الجمهور — النتيجة النظامية أعلاه.',
    },

    // ── UNIT38 / R4-GUIDE-1 — إعدادات SEO العامة (تعديل المالك UNIT39) ──
    seo: {
        meta_title: 'ديولي | Dueli — المنصة العالمية الأولى للمنافسات الحرة والشريفة (ارتقِ وتثقف واستمتع واربح)',
        default_description:
            'ديولي (Dueli) برعاية Maelsh Pro: المنصة العالمية الأولى المتخصصة في المنافسات الحرة والشريفة 100% بشتى المجالات (الحوار، العلم، والمواهب) بلا قيود سوى الضوابط الأخلاقية وبشفافية مطلقة. ارتقِ وتثقف واستمتع واربح 80% من عوائد الإعلانات في مبادرة إنسانية غير هادفة للربح.',
        pages: {
            home: 'ديولي (Dueli) برعاية Maelsh Pro: المنصة العالمية الأولى المتخصصة في المنافسات الحرة والشريفة 100% بشتى المجالات (الحوار، العلم، والمواهب) بلا قيود سوى الضوابط الأخلاقية وبشفافية مطلقة. ارتقِ وتثقف واستمتع واربح 80% من عوائد الإعلانات في مبادرة إنسانية غير هادفة للربح.',
            explore: 'استكشف المنافسات المباشرة والمسجلة على ديولي حسب الفئة والفئة الفرعية والحالة — منافسات حرة وشريفة للحوار والعلم والمواهب برعاية Maelsh Pro.',
            docs: 'وثائق ديولي المنشورة — ملاحظات المنصة وسياساتها والمحتوى المعتمد من المالك، ينشرها فريق المنصة للجميع.',
            transparency: 'دفتر ديولي المفتوح: الداخل، الخارج، حصة المنصة، وكلفة تشغيل الخدمة.',
            donate: 'ادعم ديولي بتبرع لمرة واحدة. ديولي مبادرة إنسانية غير هادفة للربح برعاية Maelsh Pro، وتنشر أرقامها المفتوحة في سجل الشفافية المالية.',
        },
    },

    // ── UNIT38 / R4-GUIDE-1 — مركز «عن ديولي والمساعدة» ──────────────
    guide: {
        title: 'دليل ديولي الشامل — الرسالة الإنسانية، التقنيات، تقدير الذكاء الاصطناعي، والسياسات',
        subtitle:
            'تعرف على ديولي (Dueli) المنصة العالمية الأولى للمنافسات الحرة والشريفة برعاية Maelsh Pro: رسالتنا الإنسانية، البنية التقنية، لوحة الشرف التقنية، حقوق النشر ورخصة الكود الأخلاقية، وقنوات التواصل الرسمية.',
        hub_intro:
            'اختر القسم الذي تحتاجه. كل قسم يفتح على عنوان خاص به، فبإمكانك حفظه ومشاركته والعودة إليه بعد التحديث.',
        nav_label: 'أقسام المركز',
        back_to_center: 'العودة إلى مركز الدليل',
        section_label: 'قسم',
        docs_note: 'الملاحظات والوثائق المنشورة متاحة في قسم المستندات.',
        managed_note:
            'يعرض هذا القسم ما ينشره المالك بوصفه وثيقة مُدارة فقط، فلا يظهر هنا أي محتوى قبل نشره.',
        links: {
            docs: 'الوثائق المنشورة',
            privacy: 'سياسة الخصوصية',
            deletion: 'تعليمات حذف البيانات',
            reports: 'الإبلاغ عن محتوى',
            complaints: 'تتبّع شكوى',
            transparency: 'الشفافية المالية',
            donate: 'دعم المنصة',
            messages: 'رسائل الإدارة',
        },
        sections: {
            overview: {
                title: 'نظرة عامة',
                desc: 'ما هي ديولي، وكيف تُدار المنافسة، وما هي هوية Maelsh Pro وراء المنصة.',
            },
            message: {
                title: 'الرسالة الإنسانية',
                desc: 'رسالة المؤسس الإنسانية: أربع ركائز، وجسر مستقبلي مع وكلاء AI مستقلين، وقصد غير هادف للربح.',
            },
            technology: {
                title: 'التقنيات',
                desc: 'مكدس ديولي الحقيقي بطبقتين: شرح مبسط وشرح هندسي.',
            },
            ai: {
                title: 'تقدير الذكاء الاصطناعي',
                desc: 'تقدير تقني لشركات ونماذج ومنصات الذكاء الاصطناعي التي ساعدت في بناء ديولي، وللأصدقاء الذين شاركوا اشتراكاتهم الشخصية.',
            },
            help: {
                title: 'المساعدة والأسئلة الشائعة',
                desc: 'أدلة الأدوار والمواضيع خطوة بخطوة والإجابات وملاحظات الوصولية.',
            },
            terms: {
                title: 'الشروط والسياسات',
                desc: 'حقوق المتنافسين والمشاهدين، والوثائق ذات الإصدار، ومسارات الإبلاغ المطبَّقة.',
            },
            contact: {
                title: 'التواصل مع Maelsh Pro',
                desc: 'النطاقات الرسمية والبريد الإلكتروني وقناة يوتيوب ومسارات التواصل داخل المنتج للوصول إلى ديولي وMaelsh Pro.',
            },
            support: {
                title: 'دعم المنصة واستمرارها',
                desc: 'كيف تُوزَّع عوائد الإعلانات 80/20، ومخطط المانحين، وطرق المساهمة بغير المال، والفصل بين دعم المنصة وأرباح المتنافسين.',
            },
        },
        // UNIT39 / R4-GUIDE-2 — الرسالة الإنسانية (تعديل المالك).
        message_content: {
            slogan: 'ارتقِ.. وتثقف.. واستمتع.. واربح',
            identity_title: 'من نحن',
            identity:
                'ديولي (Dueli) هي المنصة العالمية الأولى المتخصصة في المنافسات الحرة والشريفة بشتى أنواعها، أطلقتها وترعاها شركة Maelsh Pro كمبادرة إنسانية غير هادفة للربح؛ تهدف إلى إحلال الحوار محل النزاع، ونشر العلم، وإبراز الكفاءات البشرية بشفافية مطلقة، بلا قيود سوى الضوابط الأخلاقية.',
            pillars_title: 'أربع ركائز',
            pillars: [
                {
                    title: 'تحويل النزاع إلى حوار بنّاء (ارتقِ)',
                    body:
                        'الارتقاء بالخلافات الفكرية والثقافية من ساحات الصراع إلى مناظرات حية راقية تحترم العقل وتجمع البشر على طاولة حوار واحدة يسودها الاحترام المتبادل والبحث عن الحقيقة.',
                },
                {
                    title: 'تبسيط العلم والنظريات للعامة (تثقف)',
                    body:
                        'تقريب العلوم والنظريات المعقدة والفنون الرصينة لجمهور العالم عبر التنافس المعرفي الحي، وجعل المعرفة الموثوقة ممتعة ومتاحة لكل إنسان بمختلف اللغات.',
                },
                {
                    title: 'إبراز المواهب وربط الكفاءات بأرباب الأعمال (استمتع)',
                    body:
                        'منح كل صاحب موهبة أو فكر أو مهارة منبراً عالمياً عادلاً يبرز فيه كفاءته الحقيقية أمام الجمهور في متعة نافعة. ولا يقتصر أثر ذلك على دعم الموهوب فحسب، بل يفتح نافذة مباشرة للباحثين عن المواهب من أرباب الأعمال ومسؤولي التوظيف والمؤسسات للوصول بسهولة إلى الكفاءات المتميزة؛ مما يحسّن جودة العمل في العالم ويضع الموهبة المناسبة في المكان المناسب.',
                },
                {
                    title: 'اقتصاد تشاركي عادل واستدامة شفافة (اربح)',
                    body:
                        'لأن العقول المتنافسة هي صاحبة الفضل الأول، يُخصَّص 80% من صافي عوائد الإعلانات مباشرةً للمتنافسين، بينما تُوجَّه 20% لتغطية تكاليف التشغيل والإدارة والتطوير المستمر للمنصة.',
                },
            ],
            ai_bridge_title: 'جسر ثقة مستقبلي مع وكلاء AI مستقلين',
            ai_bridge_body:
                'تتطلع ديولي في رؤيتها المستقبلية إلى بناء جسر ثقة تقني يتيح لوكلاء الذكاء الاصطناعي المستقلين المساهمة مستقبلاً في إثراء المعرفة الإنسانية والحوار الحضاري ضمن بيئة آمنة وشفافة، دون أن يمس ذلك اليوم بنظام المصادقة أو الإدارة المالية الحالي.',
        },
        // UNIT39 / R4-GUIDE-2 — تقدير الذكاء الاصطناعي (تعديل المالك).
        ai_content: {
            intro:
                'تنطلق ديولي من مبدأ الوفاء والشفافية المطلقة؛ لذا نتقدم بخالص الشكر والتقدير لجميع شركات ومنصات الذكاء الاصطناعي التي تتيح لمستخدميها حول العالم حصص استخدام مجانية أو أرصدة تجريبية عامة (Free Public Tiers & Credits)، وكذلك للأصدقاء الداعمين الذين ساهموا باشتراكاتهم الشخصية، مما مكننا من الاعتماد على قدرات هذه النماذج الرائدة في تخطيط وبرمجة ومراجعة المنصة دون تلقي أي منح خاصة أو تمويل مباشر من تلك الشركات. ونلتمس العذر عن أي منصة أو نموذج ساهم في هذه الرحلة وسقط اسمه سهواً.',
            company_label: 'الشركة',
            model_label: 'النماذج',
            role_label: 'المساهمة',
            table_caption: 'شركات ونماذج الذكاء الاصطناعي التي ساهمت في بناء ديولي',
            entries: [
                {
                    company: 'OpenAI',
                    model: 'ChatGPT',
                    role: 'التخطيط الهيكلي وقيادة المشروع',
                },
                {
                    company: 'Anthropic',
                    model: 'Claude Opus، Claude Sonnet، Claude Haiku',
                    role: 'البرمجة والمراجعة المعمارية والتخطيط (أُتيح Claude Opus عبر المنصات الوسيطة المذكورة أدناه)',
                },
                {
                    company: 'Google / Alphabet',
                    model: 'Gemini Argon، Gemini Flash',
                    role: 'القيادة التخطيطية والتصميم المعماري والمراجعة الشاملة (أُتيحت عبر المنصات الوسيطة المذكورة أدناه)',
                },
                {
                    company: 'Z.ai',
                    model: 'GLM، GLM Flash',
                    role: 'البرمجة والتخطيط والمراجعة التقنية',
                },
                {
                    company: 'Moonshot AI',
                    model: 'Kimi K',
                    role: 'التحليل والتخطيط',
                },
            ],
            additional_title: 'نماذج رائدة أخرى أثبتت كفاءتها العالية',
            additional_intro:
                'استُخدمت هذه النماذج كذلك عبر المنصات المجانية أو اشتراكات الأصدقاء الداعمين:',
            additional: [
                { company: 'DeepSeek', model: 'DeepSeek Flash' },
                { company: 'MiniMax', model: 'MiniMax Flash' },
                { company: 'Meta / Muse', model: 'Muse Spark وMuse Wonder' },
                { company: 'مزودون آخرون', model: 'نماذج ذكية مساندة أخرى' },
            ],
            platforms_title: 'منصات الإتاحة وبيئات التطوير الذكية',
            platforms_intro:
                'وفرت المنصات وبيئات التطوير التالية الوصول إلى هذه النماذج:',
            platforms: [
                'Genspark AI (جين اسبارك ايه آي)',
                'OpenRouter (أوبن راوتر)',
                'Cursor (كرسر)',
                'Antigravity (أنتي جرافيتي)',
                'Google AI Studio (جوجل ايه آي استوديو)',
                'Cline Code (كلاين كود)',
                'Kilo Code (كيلو كود)',
                'OpenCode (أوبن كود)',
            ],
            infrastructure_title: 'الاستضافة والبنية التحتية',
            infrastructure_body:
                'شكر خاص لمنصات الاستضافة والمستودعات: GitHub (حاضنة الكود المصدري وبوابات الفحص المستمر) وCloudflare (شبكة الحافة العالمية، وWorkers، وPages، وقاعدة بيانات D1) التي تحمل المنصة.',
            appeal_title: 'نداء الخير',
            appeal:
                'ندعو جميع شركات التقنية والذكاء الاصطناعي حول العالم إلى إتاحة المزيد من أدواتها المجانية لدعم المبادرات الخيرية والإنسانية؛ فلولا ما أتيح من هذا الخير لما ظهرت منصة ديولي إلى النور، وبتكاتف التقنية مع القيم الإنسانية يصبح العالم مكاناً أفضل.',
            disclaimer:
                'تُذكر هذه الشركات والمنصات والنماذج من باب التقدير والوفاء التقني لما أتاحته من أدوات عامة ساهمت في بناء ديولي، دون أن يعني ذلك شراكة تجارية أو رعاية رسمية أو التزاماً متبادلاً أو ملكية لأي طرف.',
            updates_title: 'كيف يُحدَّث هذا الجرد؟',
            updates_body:
                'هذا الجرد جزء من نص المنصة. أي إضافة أو تصحيح تُسجَّل في وثيقة مُدارة عبر لوحة المدير القائمة (H9) تظهر في قسم الوثائق؛ ولا يُنشأ نظام محتوى موازٍ.',
            docs_link: 'الوثائق المنشورة',
        },
        // UNIT39 / R4-GUIDE-2 — صفحة التقنيات بطبقتين (تعديل المالك).
        technology_content: {
            intro:
                'تشرح هذه الصفحة التقنيات التي يستخدمها ديولي فعلاً، بطبقتين: شرح مبسط للجميع، وشرح هندسي للمختصين. ولا تُذكر تقنية ما لم يكن الكود الحالي يستخدمها.',
            simple_title: 'ببساطة',
            simple_paragraphs: [
                'يعمل ديولي في المتصفح على شبكة Cloudflare العالمية. يلتقي المتنافسان في مكالمة فيديو مباشرة بين جهازيهما (WebRTC نقطة لنقطة)؛ وعندما تمنع الشبكة المسار المباشر يساعد مرحّل TURN على إتمام الاتصال.',
                'أثناء المنافسة يجمع المتصفح كاميرتي الطرفين في صورة واحدة ويسجلها على شكل مقاطع قصيرة مدتها 5 ثوانٍ. تُرفع المقاطع أولاً بأول، ويمكن تشغيلها بالترتيب، ثم تُجمع في تسجيل كامل بعد انتهاء المنافسة.',
                'يمكن تنزيل المنافسات المسجلة كملف MP4. وعندما يحتاج التسجيل إلى تحويل، يجري التحويل داخل متصفح الزائر باستخدام FFmpeg.wasm، فلا يُرسل الملف إلى خدمة تحويل خارجية.',
                'تعيش بيانات المنصة في D1، وتُبنى الصفحات والواجهات البرمجية بـ Hono وTypeScript على Cloudflare، وتستخدم الواجهة Tailwind CSS. تصل التحديثات الحية عبر SSE والاستقصاء الدوري.',
            ],
            engineering_title: 'للمهندسين',
            engineering_paragraphs: [
                'التشغيل: Cloudflare Pages/Workers مع Hono 4 على TypeScript. قاعدة البيانات D1 (SQLite). يبني Vite حزمة الـWorker، ويُنسّق Tailwind CSS 4 الواجهة، ويجمع esbuild نقاط دخول المتصفح.',
                'الوسائط الحية: RTCPeerConnection في المتصفح ينقل WebRTC بين المضيف والخصم. تُصدر خوادم ICE لكل جلسة من GET /api/signaling/ice-servers؛ ويمكن أن يمر الترحيل عبر Cloudflare Calls TURN (TURN_TOKEN_ID وTURN_API_TOKEN) أو coturn ذاتي الاستضافة (TURN_URL وTURN_SECRET)، مع رجوع إلى STUN فقط عند غياب أي منهما.',
                'التسجيل: مركّب canvas يرسم البثين، ويصدر MediaRecorder مقطعاً كل 5 ثوانٍ. يسجّل المضيف كل مقطع في POST /api/chunks/register (مفتاح أحادي قصير العمر مرتبط بالمنافسة والتسلسل وسقف البايتات)، ثم يرفعه، ويتحقق منه عبر GET /verify ويبلغ عبر POST /receipt. يقرأ التشغيل GET /api/chunks/playlist/:id، وتُنتج خطوة finalize القائمة ملف VOD.',
                'التنزيلات: يعمل @ffmpeg/core 0.12.10 داخل عامل مستضاف على النطاق نفسه لتحويل MP4 في المتصفح، مع مسار إعادة تركيب بنيوي للتسجيلات المتوافقة أصلاً مع MP4. وتُدار حدود التقدم والذاكرة في خدمة العميل.',
                'الزمن الحقيقي: يحمل SSE عبر GET /api/sse التحديثات الحية، ويستخدم signaling الاستقصاء عبر HTTP؛ ومسار الإنتاج لا يستخدم WebSocket.',
                'الجودة: يغطي Vitest عقود الوحدات والواجهات، ويغطي Playwright مسارات المتصفح من طرف إلى طرف. وتُعرض وثائق Markdown عبر marked، ويكتمل مسار CSS بـ PostCSS وAutoprefixer.',
            ],
            stack_title: 'المكدس في هذا المستودع',
            stack: [
                { name: 'Cloudflare Pages / Workers', role: 'الاستضافة وتشغيل الخادم' },
                { name: 'Cloudflare D1 (SQLite)', role: 'قاعدة بيانات التطبيق' },
                { name: 'Hono 4', role: 'مسارات HTTP والصفحات والواجهات البرمجية' },
                { name: 'TypeScript 5', role: 'شيفرة مكتوبة بأنواع للخادم والعميل' },
                { name: 'Tailwind CSS 4 + PostCSS + Autoprefixer', role: 'تنسيق الواجهة ومسار CSS' },
                { name: 'Vite 7 + esbuild', role: 'بناء حزمة Worker ونقاط دخول المتصفح' },
                { name: 'WebRTC (RTCPeerConnection) + TURN/STUN', role: 'الصوت والفيديو المباشران بين المشاركين' },
                { name: 'Canvas compositor + MediaRecorder', role: 'مقاطع مسجلة مدتها 5 ثوانٍ في المتصفح' },
                { name: 'FFmpeg.wasm (@ffmpeg/core 0.12.10)', role: 'تحويل MP4 وتنزيله داخل المتصفح' },
                { name: 'marked 17', role: 'عرض Markdown للوثائق المُدارة' },
                { name: 'Vitest 5', role: 'اختبارات الوحدات والواجهات' },
                { name: 'Playwright', role: 'اختبارات المتصفح من طرف إلى طرف' },
                { name: 'Wrangler 4', role: 'أدوات تطوير ونشر Cloudflare' },
                { name: 'SSE + HTTP polling', role: 'التحديثات الحية خارج مسار الوسائط' },
            ],
            note: 'تقتصر القائمة على ما يحتويه package.json والمستودع فعلاً. وهي وصف تقني لا ادعاء شراكة أو تأييد.',
        },
        // UNIT39 / R4-GUIDE-2 — الدعم والمانحون ونموذج 80/20.
        support_content: {
            intro:
                'كيف تُدعم المنصة، وكيف تُوزَّع عوائد الإعلانات، وكيف تستمر ديولي كمبادرة إنسانية غير هادفة للربح.',
            split_title: 'عوائد الإعلانات: توزيع 80% / 20%',
            split_80_title: '80% للمتنافسين',
            split_80_body:
                'تُقسَّم حصة المتنافسين بين طرفي المنافسة وفق نسبة متوسط تقييمات الجمهور لكل منهما، وبالتساوي عند التعادل أو غياب التقييمات — وفق دورة الأرباح القائمة.',
            split_20_title: '20% لتشغيل المنصة واستدامتها وتطويرها',
            split_20_body:
                'تغطي هذه الحصة تكاليف التشغيل والصيانة والتطوير. النسبة قابلة للضبط في إعدادات المنصة، وتُنشر أرقامها المفتوحة في سجل الشفافية المالية.',
            split_note:
                'يصف هذا النص النموذج القائم؛ وهو ليس وعداً بأرباح أو مواعيد. والمخططات التطويرية المستقبلية مفتوحة لرعاية المانحين وفق الشروط المنشورة.',
            donors_title: 'المانحون والداعمون — رؤية مرحلية',
            donors: [
                {
                    title: 'المرحلة 1: نشر ما يُنفق',
                    body: 'إبقاء السجل المفتوح محدَّثاً ليرى الجميع ما يدخل وما يخرج.',
                },
                {
                    title: 'المرحلة 2: توضيح الدعم لمرة واحدة',
                    body: 'تحسين مسار الدعم لمرة واحدة القائم وشرح ما يموّله بالضبط؛ دون إدخال مزود دفع جديد لهذا الغرض.',
                },
                {
                    title: 'المرحلة 3: تقدير الداعمين',
                    body: 'إذا أُضيف سطح لتقدير الداعمين لاحقاً فسيُعلن عبر الوثائق المنشورة. هذا اتجاه لا التزام بموعد.',
                },
            ],
            donors_note:
                'هذه مراحل اتجاهية لا مواعيد مضمونة. أي قناة دعم مستقبلية يجب أن تستخدم مسار الدفع القائم وتحصل على اعتماد المالك قبل الإعلان عنها.',
            future_title: 'التطوير المستقبلي مفتوح لرعاية المانحين',
            future_body:
                'تُنشر المخططات التطويرية المستقبلية المعتمدة حين تُعدّ، وهي مفتوحة لرعاية المانحين عبر مسار الدعم لمرة واحدة القائم. لا يُدخل مزود دفع جديد ولا مسار دفع جديد، ولا يُوعد بأرباح أو مواعيد.',
            nonfinancial_title: 'مساهمة بغير المال',
            nonfinancial: [
                'شارك الفكرة مع من قد يستخدمها، وتحدّث عن المشروع بصدق.',
                'ساهم في الأجزاء التي ينشرها المشروع علناً، وفق ترخيصها المنشور.',
                'أبلغ عن مشكلة أو اقترح تحسيناً عبر مسارات البلاغات والدعم القائمة.',
            ],
            separation_title: 'دعم المنصة ليس أرباح المتنافسين',
            separation_body:
                'دعم المنصة يمر عبر /donate وتظهر أرقامه المفتوحة في /transparency. أما أرباح المتنافسين فتأتي من دورة الأرباح القائمة بعد المنافسة، وتبرعات الجمهور للمتنافسين مسار منفصل داخل المنتج. لا يُخلط بين الاثنين، ولا تفتح هذه الصفحة أي مسار دفع جديد.',
        },
        // UNIT39 / R4-GUIDE-2 — الشروط والحقوق (تعديل المالك).
        terms_content: {
            intro:
                'توضح هذه الصفحة الحقوق والواجبات المطبقة على ديولي، وتربطها بوثائق السياسات المنشورة. الوثيقة ذات الإصدار في قسم الوثائق هي المرجع؛ وهذه الصفحة شرح مبسط.',
            clauses_title: 'الشروط والحقوق',
            clauses: [
                {
                    title: '1. حقوق النشر والاستخدام الترويجي والعوائد الإعلامية للمنصة',
                    body:
                        'بمجرد إنشاء المنافسة أو المشاركة في بثها على منصة ديولي، يمنح المتنافسون إدارة المنصة وشركة Maelsh Pro ترخيصاً عالمياً دائماً وغير حصري وغير قابل للإلغاء لاستخدام كافة الوسائط والمقاطع الصوتية والمرئية والنصوص المنشأة داخل المنصة، وإعادة نشرها كاملةً أو مجزأةً على وسائل التواصل الاجتماعي (بما فيها يوتيوب وجميع المنصات الرقمية والإعلامية الأخرى) لأغراض التوثيق والدعاية والترويج للمنصة ورسالتها. ولا يحق لأي متنافس المطالبة بمنع هذا النشر أو حذفه، كما يحق لإدارة المنصة استخدام أي عوائد أو أرباح تنتج عن ذلك النشر الخارجي بالطريقة التي تراها مناسبة لدعم المنصة وتشغيلها وتطويرها.',
                    items: [
                        'المتنافسون: يحق لكلا المتنافسين تنزيل مواد منافستهما وإعادة نشرها والانتفاع منها عبر قنواتهما الخاصة وفق الشروط المنشورة.',
                        'المشاهدون: يُسمح للمشاهد بالمشاهدة والتنزيل للاستخدام الشخصي غير التجاري فقط، ويمتنع عليه إعادة النشر العام أو التجاري دون إذن مسبق من المنصة.',
                    ],
                },
                {
                    title: '2. رخصة الكود المصدري الأخلاقية وميثاق الشفافية والاستمرارية',
                    body:
                        'تطرح ديولي كودها المصدري بشفافية لخدمة الإنسانية وفق ثلاثة شروط حاكمة وملزمة قانونياً وأخلاقياً:',
                    items: [
                        'حظر الاستخدام الضار: لا يحق لأي فرد أو جهة استخدام كود المنصة إلا في عمل خير يخدم الإنسان والمعرفة، ويُحظر استخدامه في أي نشاط يخالف القيم الأخلاقية أو يضر بالمجتمعات.',
                        'حظر التربح بدون إذن: لا يحق لأي شخص أو كيان استخدام كود المنصة لأغراض تجارية أو للتربح المادي إلا بإذن خطي مباشر ومسبق من الإدارة الأصلية للمنصة (شركة Maelsh Pro) وبالتنسيق الكامل معها.',
                        'بروتوكول الاستمرارية وفك القيود (ضمانة الشفافية القصوى): في حال تعرضت المنصة أو إدارتها لأي ضغوط قسرية خارجية تسببت في إخلال واضح ومثبت بمبدأ الشفافية أو حرفتها عن رسالتها الإنسانية، فإنه يحق لأي طرف نزيه لا يهدف للتربح إطلاقاً أن يستخدم الكود المصدري لإعادة نشر وتشغيل المنصة على نفقته الخاصة بدون قيود لاستمرار رسالتها، بشرط وحيد وملزم: أن يوجّه نسبة الـ 20% من عوائد الإعلانات إلى الإدارة الأصلية المؤسسة للمنصة (شركة Maelsh Pro) لتمكينها من الدفاع عن المنصة ومحاولة فك تلك القيود واستعادة مسارها الأصلي.',
                    ],
                },
                {
                    title: '3. سياسة الخصوصية وحماية البيانات',
                    body:
                        'توضح المنصة البيانات التي تجمعها بشفافية: بيانات الحساب، والجلسات الآمنة HttpOnly، ومشاركات البث والتعليقات والتقييمات التي ينشرها المستخدم بإرادته. وتلتزم بعدم بيع البيانات الشخصية لأي طرف ثالث، وبحق المستخدم في تعديل ملفه الشخصي، وتغيير كلمة مروره، وحذف منافسته المعلقة قبل انضمام خصم.',
                },
                {
                    title: '4. تحكم المتنافس في الإعلانات',
                    body:
                        'يثبت للمتنافس حقه في التحكم الأخلاقي بالإعلانات التجارية التي تظهر في منافساته عبر إعدادات حسابه (الموافقة اليدوية أو التلقائية وقوائم السماح والحظر)، مع استثناء الإعلانات التعريفية الرسمية الخاصة بمنصة ديولي (House Ads).',
                },
                {
                    title: '5. النزاهة المالية ونزاهة التقييم',
                    body:
                        'يشترط احتساب تقييم الجمهور مشاهدة فعلية موثقة لا تقل عن 300 ثانية، ويُحظر أي تلاعب آلي بالمشاهدات أو النقرات الإعلانية أو التقييمات، وتُطبق قواعد التسوية الذرية عند الانسحاب المبكر.',
                },
                {
                    title: '6. ميثاق شرف الحوار وإخلاء المسؤولية عن المحتوى',
                    body:
                        'يلتزم المتنافسون بآداب الحوار، ويُحظر خطاب الكراهية والتشهير والانتهاكات القانونية. والآراء المطروحة في المنافسات تعبّر عن أصحابها من المتنافسين ولا تعبّر بالضرورة عن رأي منصة ديولي أو شركة Maelsh Pro.',
                },
                {
                    title: '7. حوكمة الوثائق ذات الإصدار (H9)',
                    body:
                        'تُدار الشروط والسياسات كوثائق ذات إصدار وتاريخ تحديث واضح في /docs عبر نظام H9، وأي خطوة قبول تُوثَّق هناك قبل تفعيلها.',
                },
            ],
            policies_title: 'السياسات المطبقة',
            note:
                'هذه الصفحة ليست بديلاً عن الوثائق القانونية المنشورة. المراجعة القانونية النهائية من اختصاص مسار الإصدار المخصص لها.',
        },
        contact_content: {
            intro:
                'القنوات والنطاقات الرسمية لديولي وشركة Maelsh Pro هي المذكورة في هذه الصفحة وفي الوثائق الرسمية.',
            domains_title: 'النطاقات الرسمية',
            domains: [
                {
                    label: 'dueli.win',
                    href: 'https://dueli.win',
                    desc: 'نطاق الافتتاحية والتوجيه الرسمي: يفتح صفحة الترحيب ثم يوجّه تلقائياً إلى رابط المنصة العامل.',
                },
                {
                    label: 'dueli.maelshpro.com',
                    href: 'https://dueli.maelshpro.com',
                    desc: 'رابط المنصة العامل الحالي، وهو نطاق فرعي للشركة المؤسسة.',
                },
            ],
            channels_title: 'قنوات التواصل الرسمية داخل المنصة',
            channels: [
                {
                    label: 'رسائل الإدارة',
                    desc: 'مراسلة إدارة المنصة مباشرة في محادثة خاصة، وتتطلب تسجيل الدخول.',
                },
                {
                    label: 'الإبلاغ عن محتوى',
                    desc: 'أبلغ عن منافسة أو ملف أو تعليق أو إعلان للمراجعة.',
                },
                {
                    label: 'تتبّع شكوى',
                    desc: 'تابع شكوى قدّمتها وحالتها.',
                },
            ],
            external_title: 'البريد الإلكتروني الرسمي والقنوات الخارجية المعتمدة',
            external: [
                {
                    label: 'dueli@maelshpro.com',
                    href: 'mailto:dueli@maelshpro.com',
                    desc: 'البريد الإلكتروني الرسمي لمنصة ديولي.',
                },
                {
                    label: 'info@maelshpro.com',
                    href: 'mailto:info@maelshpro.com',
                    desc: 'البريد الإلكتروني الرسمي للشركة المؤسسة والراعية، Maelsh Pro.',
                },
                {
                    label: 'YouTube — @Maelsh-Dueli',
                    href: 'https://www.youtube.com/@Maelsh-Dueli',
                    desc: 'قناة يوتيوب الرسمية لمنصة ديولي.',
                },
            ],
            security_title: 'تنبيه الأمان الرسمي',
            security_notice:
                'هذه القنوات والنطاقات المذكورة أعلاه هي القنوات الرسمية الوحيدة المعتمدة لمنصة ديولي وشركة Maelsh Pro، وأي حساب أو قناة أخرى غير مدرجة في هذه الصفحة أو في الوثائق الرسمية لا تمثل المنصة.',
            response_note:
                'لا نعد بزمن استجابة محدد. تُتابع البلاغات والدعم عبر الأنظمة القائمة.',
        },
        // دليل الكاميرا الافتراضية في OBS (للمحاورين).
        obs: {
            title: 'دليل: الكاميرا الافتراضية في OBS للمحاورين',
            intro:
                'يستطيع OBS إظهار كاميرا افتراضية تلتقطها ديولي كأي كاميرا عادية. يوضح هذا الدليل أقصر طريق من OBS إلى كاميرا مباشرة داخل غرفة المنافسة.',
            step_1_t: 'جهّز المشهد في OBS',
            step_1_d:
                'أضف المصادر التي تريد بثّها (شاشة أو نافذة أو كاميرا) ورتّبها في مشهد واحد قبل المتابعة.',
            step_2_t: 'شغّل الكاميرا الافتراضية في OBS',
            step_2_d:
                'من لوحة Controls في OBS اضغط «Start Virtual Camera». يسجّل OBS عندئذٍ كاميرا باسم «OBS Virtual Camera» في نظام التشغيل.',
            step_3_t: 'اسمح للمتصفح باستعمال تلك الكاميرا',
            step_3_d:
                'عندما تطلب ديولي الكاميرا يعرض المتصفح الكاميرا التي سيستعملها. اختر فيها «OBS Virtual Camera» — فالغرفة نفسها لا تحتوي منتقي أجهزة.',
            step_4_t: 'شغّل الكاميرا داخل الغرفة',
            step_4_d:
                'في غرفة المنافسة اضغط زر الكاميرا لتفعيلها، وتحقق من أن المعاينة المحلية تعرض مشهد OBS.',
            step_5_t: 'انشر لتبدأ البث',
            step_5_d:
                'تبقى المعاينة على جهازك. اضغط زر النشر لإرسال كاميراك إلى الطرف الآخر والجمهور.',
            alt_t: 'مشاركة نافذة OBS بدل ذلك',
            alt_d:
                'يمكنك أيضاً مشاركة نافذة OBS بزر «مشاركة الشاشة». هذا الطريق لا يحتاج كاميرا افتراضية ولا اختيار كاميرا في المتصفح.',
            note_t: 'عن أزرار الكاميرا',
            note_d:
                'زر الكاميرا يشغّلها ويوقفها، وزر تبديل الكاميرا يبدّل بين الكاميرا الأمامية والخلفية في الهاتف — وهو لا يختار بين الأجهزة. اختيار الجهاز يتم في المتصفح أو نظام التشغيل.',
        },
    },

    // ── UNIT38 / R4-GUIDE-1 — بوابة الافتتاحية /welcome ──────────────
    splash: {
        title: 'ديولي',
        word_1: 'ارتقِ',
        word_2: 'تثقف',
        word_3: 'استمتع',
        word_4: 'اربح',
        by_maelsh_pro: 'By Maelsh Pro',
        skip: 'تخطَّ ودخل ديولي الآن',
        redirecting: 'جارٍ تحويلك إلى ديولي…',
        redirect_failed: 'تعذّر التحويل. افتح الرابط أعلاه.',
    },

    // ── T1.3: البث ──────────────
    recording_processing: 'جاري تجهيز التسجيل...',
    // ── R4-CHUNK-PLAY-1: حالات المشاهدة للجمهور ──────────────
    recording_not_ready: 'التسجيل غير متاح',
    // ── UNIT30.6 D-02: حالة صادقة لمنافسة مكتملة بلا تسجيل ──────────────
    recording_none: 'لا يوجد تسجيل لهذه المنافسة',
    streaming_unavailable: 'خدمة البث غير متاحة',
    connecting_to_stream: 'جارٍ الاتصال بالبث...',
    loading_video: 'جارٍ تحميل الفيديو...',
    stream_ended: 'انتهى البث',
    chunk: 'قطعة',

    // ── T3.3: التعليقات المتداخلة ──────────────
    reply: 'رد',
    replying_to: 'ترد على:',

    // ── R2-L2: تعليقات VOD الموقوتة ──────────────
    vod_comment_at: 'انتقال إلى اللحظة',

    // ── T3.2: منشورات البروفايل ──────────────
    post_placeholder: 'شارب جمهورك فكرة...',
    post_publish: 'نشر',
    confirm_delete_post: 'حذف هذا المنشور؟',

    // ── T3.2: حذف الحساب (GDPR) ──────────────
    danger_zone: 'منطقة الخطر',
    delete_account: 'حذف الحساب',
    delete_account_warning: 'حذف حسابك نهائي ولا يمكن التراجع عنه.',
    confirm_delete_account: 'هل أنت متأكد من حذف حسابك نهائياً؟ سيتم إخفاء هويتك وحذف بياناتك.',
    account_deleted: 'تم حذف حسابك. نأسف لرحيلك.',

    // ── T2.2: الإشعارات الفورية عبر SSE ──────────────
    sse: {
        new_invite: 'يدعوك للمنافسة!',
        invite_accepted: 'قبل الدعوة ✅',
        invite_declined: 'رفض الدعوة',
    },

    // ── المهمة 10: المطابقة الديناميكية ولوحة الدعوات ──────────────
    matchmaking: {
        panel_title: 'دعوة خصم',
        search_users: 'ابحث عن مستخدمين...',
        online_now: 'متصل الآن',
        recently_active: 'نشط مؤخراً',
        offline: 'غير متصل',
        send_invite: 'إرسال دعوة',
        invite_sent: 'تم إرسال الدعوة!',
        sending: 'جاري الإرسال...',
        no_users_available: 'لا يوجد مستخدمون متاحون حالياً',
        already_has_opponent: 'المنافسة لديها خصم بالفعل',
        competition_not_open: 'المنافسة غير مفتوحة للدعوات',
        compatibility: 'التوافق',
        compatibility_unavailable: 'غير متاح',
        wins_label: 'الانتصارات',
        competitions_label: 'المنافسات',
        rating_label: 'التقييم',
        close_panel: 'إغلاق اللوحة',
        refresh: 'تحديث',
        auto_updating: 'يتم التحديث تلقائياً كل 10 ثوانٍ',
        blocked_user: 'مستخدم محظور',
        busy_status: 'مشغول حالياً',
        invite_opponent_btn: 'دعوة خصم',
        stats_winrate: 'نسبة الفوز',
        stats_losses: 'خسائر',
        stats_top_categories: 'أبرز المجالات',
        view_profile: 'عرض الملف',
        loading_users: 'جاري تحميل المستخدمين المتاحين...',
    },

    // ── المهمة 7: محرك التوصيات المتقدم ──────────────────
    recommendations: {
        carousel_title: 'مقترح لك',
        no_recommendations: 'لا توجد توصيات بعد. ابدأ بمشاهدة المنافسات!',
        competitor_stats: 'إحصائيات المتنافس',
        losses: 'الخسائر',
        win_rate: 'نسبة الفوز',
        top_categories: 'أفضل الأقسام',
        degraded_notice: 'عرض نتائج أوسع لك',
        for_you: 'للمستخدم',
        trending: 'الشائع',
        empty: 'لا توجد منافسات تتناسب مع تفضيلاتك حالياً. راجع لاحقاً!',
    },

    // ── المهمة 8: دورة حياة المنافسات والمؤقتات الصارمة ──
    timers: {
        time_to_join: 'الوقت المتبقي للانضمام:',
        time_to_start: 'الوقت للبدء:',
        broadcast_ends_in: 'ينتهي البث في',
        expired: 'انتهى الوقت',
    },
};

